/* v2026-05-13: MAIN_PRODUCT_TYPES (Zubehoer-Demotion-Fix) */
/**
 * Typesense Search fuer markenkoffer.de
 * Ersetzt Shopify Predictive Search durch Typesense Cloud.
 * Zweispaltiges Layout: Links Vorschlaege, Rechts Produktergebnisse.
 */

// GA4 Tracking läuft vollständig über Shopify Custom Pixel (GTM-NMQKXLPG).

const TYPESENSE_CONFIG = {
  host: 'iwmzu7e9k26dgj0vp-1.a1.typesense.net',
  port: 443,
  protocol: 'https',
  searchKey: '3C7uE59csW8hkyDrQvuvY9SAUglMuu4N',
  collection: `products_${(window.ISO_CODE || 'DE').toLowerCase()}`,
};

const TS_AC_LANG = (window.ISO_CODE || 'DE').toLowerCase();

// Marktpreise je Land (Vertrag docs/marktpreise_handles.md, Abschnitt 6). Liste identisch mit sync/markets.py.
// price/compare_at_price = Heimatmarkt der Sprache, price_<cc>/compare_at_price_<cc> = Preis im Land des Kunden.
const MARKET_PRICE_COUNTRIES_AC = ['AT','FR','IT','ES','BE','CZ','DK','FI','GR','HR','HU','LU','NL','PL','RO','SE','SI','SK'];
function detectMarketCountryAC() {
  const ok = c => (typeof c === 'string' && /^[A-Za-z]{2}$/.test(c.trim())) ? c.trim().toUpperCase() : '';
  const fromGlobals = ok(window.MK_COUNTRY) || ok(window.Shopify && window.Shopify.country);
  if (fromGlobals) return fromGlobals;
  const host = (window.location.hostname || '').toLowerCase();
  return { at: 'AT', fr: 'FR', it: 'IT', es: 'ES' }[host.split('.').pop()] || 'DE';
}
const MARKET_CC_AC = detectMarketCountryAC();
const HAS_MARKET_PRICE_AC = MARKET_PRICE_COUNTRIES_AC.includes(MARKET_CC_AC);
const PRICE_FIELD_AC = HAS_MARKET_PRICE_AC ? 'price_' + MARKET_CC_AC.toLowerCase() : 'price';
const COMPARE_FIELD_AC = HAS_MARKET_PRICE_AC ? 'compare_at_price_' + MARKET_CC_AC.toLowerCase() : 'compare_at_price';
// Preis/UVP eines Dokuments im Land des Kunden; Altdokument ohne Marktfeld: Heimatpreis (Paar bleibt zusammen)
function marketPriceOfAC(doc) {
  return (HAS_MARKET_PRICE_AC && doc[PRICE_FIELD_AC] != null)
    ? { price: doc[PRICE_FIELD_AC], compare: doc[COMPARE_FIELD_AC] }
    : { price: doc.price, compare: doc.compare_at_price };
}

// Sprachpraefix der Shop-Seite aus theme.routes.root_url ("/" -> "", "/en" -> "/en"), ohne Schluss-Slash.
// Alle selbst gebauten Links laufen darueber, sonst landet EN-Kundschaft auf der deutschen Seite.
function rootPrefixAC() {
  try {
    const r = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    return String(r).replace(/\/+$/, '');
  } catch (e) { return ''; }
}
function localePathAC(path) {
  return rootPrefixAC() + '/' + String(path).replace(/^\/+/, '');
}
// Marken-Link (Reihenfolge mit typesense-search-page.js abgestimmt):
// (a) BRAND_HANDLES geladen und Marke enthalten -> /collections/<handle>
// (b) geladen, Marke fehlt -> /collections/vendors?q=<Name>
// (c) noch nicht geladen -> geratener Slug mit Umschrift (NFD, Diakritika weg, ss), wie bisher.
function brandUrlAC(vendor) {
  const name = String(vendor || '');
  let map = null;
  try {
    const m = window.BRAND_HANDLES;
    if (m && typeof m === 'object' && Object.keys(m).length > 0) map = m;
  } catch (e) { /* defensiv */ }
  if (map) {
    const h = map[name.toLowerCase()];
    if (typeof h === 'string' && h) return localePathAC('/collections/' + h);
    return localePathAC('/collections/vendors') + '?q=' + encodeURIComponent(name);
  }
  const slug = name.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  // Leerer Slug (Name nur aus Sonderzeichen): nie /collections/ liefern, sondern die Herstellersuche
  if (!slug) return localePathAC('/collections/vendors') + (name ? '?q=' + encodeURIComponent(name) : '');
  return localePathAC('/collections/' + slug);
}
// Linksklick ohne Modifier: nur dann navigieren wir selbst; Rechts-/Mittelklick und Strg/Cmd/Shift/Alt macht der Browser (Kontextmenue, neuer Tab).
function isPlainLeftClickAC(e) {
  return !!e && (e.button === undefined || e.button === 0) && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;
}
// Eingabe ohne einen einzigen Buchstaben/Ziffer (nur & < " ' * ...) zaehlt wie ein leeres Feld.
function hasSearchableTextAC(s) {
  return /[\p{L}\p{N}%]/u.test(String(s || ''));
}
// Anfuehrungszeichen je Sprache (vorher fest deutsch)
const QUOTES_AC = { de: ['„', '“'], en: ['“', '”'], fr: ['« ', ' »'], it: ['“', '”'], es: ['“', '”'], nl: ['„', '”'] };
function quoteAC(text) {
  const q = QUOTES_AC[TS_AC_LANG] || QUOTES_AC.de;
  return q[0] + text + q[1];
}

// Marken ohne UVP-Anzeige (Streichpreis/Sale-Rot), kleingeschrieben. Muss mit snippets/product-price.liquid uebereinstimmen.
const UVP_HIDDEN_VENDORS = ['ortlieb'];

// Collection Title -> Handle Map (wird aus Suchergebnissen aufgebaut)
let _collectionHandleMap = {};

// --- Search Analytics (non-blocking) ---
const _analyticsUrl = 'https://webhooks.markenkoffer.de/analytics/event';
let _lastSearchQuery = '';
// Dedup: gleiche (type+query) innerhalb 60s pro Tab nicht doppelt tracken
const _AC_TRACK_DEDUP_MS = 60000;
function _acShouldTrack(type, query) {
  try {
    const key = type + ':' + (query || '').toLowerCase().trim();
    const now = Date.now();
    const store = JSON.parse(sessionStorage.getItem('ts_last_tracked') || '{}');
    const keys = Object.keys(store);
    if (keys.length > 20) {
      keys.sort((a, b) => store[a] - store[b]).slice(0, keys.length - 20).forEach(k => delete store[k]);
    }
    if (store[key] && now - store[key] < _AC_TRACK_DEDUP_MS) return false;
    store[key] = now;
    sessionStorage.setItem('ts_last_tracked', JSON.stringify(store));
    return true;
  } catch (e) { return true; }
}
function trackSearch(type, query, extra = {}) {
  try {
    // Klicks immer tracken
    if (type !== 'click' && !_acShouldTrack(type, query)) return;
    const body = JSON.stringify({ type, query, ...extra });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(_analyticsUrl, new Blob([body], { type: 'application/json' }));
    }
  } catch (e) { /* silent */ }
}
const AC_I18N = {
  de: { searchSuggestions: 'Suchvorschl\u00e4ge', categorySuggestions: 'Kategorievorschl\u00e4ge', brandSuggestions: 'Markenvorschl\u00e4ge', seriesSuggestions: 'Serienvorschl\u00e4ge', productSuggestions: 'Produktvorschl\u00e4ge', noResults: 'Keine Ergebnisse f\u00fcr', allResults: 'Alle {count} Ergebnisse anzeigen', aiRecommendation: 'KI-Empfehlung', aiLoading: 'Empfehlung wird geladen...', allCategories: 'Alle Kategorien', inCategory: 'in', brandNotCarried: 'Die Marke \u201e{brand}\u201c f\u00fchren wir leider nicht.', partnershopHeader: '\u201e{brand}\u201c finden Sie bei unserem Partnershop', partnershopHint: 'Bei premiumbags.com f\u00fcr Sie verf\u00fcgbar:', partnershopCta: 'Bei premiumbags.com ansehen', storeOnlyHeader: '„{brand}“ finden Sie in unserem Ladengeschäft', storeOnlyHint: 'Anfrage per Mail — wir erstellen Ihnen ein Angebot:', storeOnlyCta: 'Anfrage per Mail senden', tryInstead: 'Vielleicht interessiert Sie:', popularBrands: 'Beliebte Marken', popularCategories: 'Beliebte Kategorien' },
  en: { searchSuggestions: 'Search suggestions', categorySuggestions: 'Category suggestions', brandSuggestions: 'Brand suggestions', seriesSuggestions: 'Series suggestions', productSuggestions: 'Product suggestions', noResults: 'No results for', allResults: 'Show all {count} results', aiRecommendation: 'AI Recommendation', aiLoading: 'Loading recommendation...', allCategories: 'All categories', inCategory: 'in', brandNotCarried: 'We don\u2019t carry the brand \u201c{brand}\u201d.', partnershopHeader: 'You can find \u201c{brand}\u201d at our partner shop', partnershopHint: 'Available for you at premiumbags.com:', partnershopCta: 'View at premiumbags.com', storeOnlyHeader: 'You can find “{brand}” in our boutique', storeOnlyHint: 'Request a tailored offer by email:', storeOnlyCta: 'Send email request', tryInstead: 'You might like:', popularBrands: 'Popular brands', popularCategories: 'Popular categories' },
  fr: { searchSuggestions: 'Suggestions de recherche', categorySuggestions: 'Cat\u00e9gories', brandSuggestions: 'Marques', seriesSuggestions: 'S\u00e9ries', productSuggestions: 'Produits sugg\u00e9r\u00e9s', noResults: 'Aucun r\u00e9sultat pour', allResults: 'Afficher les {count} r\u00e9sultats', aiRecommendation: 'Recommandation IA', aiLoading: 'Chargement...', allCategories: 'Toutes les cat\u00e9gories', inCategory: 'dans', brandNotCarried: 'Nous ne proposons pas la marque \u00ab\u202f{brand}\u202f\u00bb.', partnershopHeader: '\u00ab\u202f{brand}\u202f\u00bb est disponible chez notre partenaire', partnershopHint: 'Disponible chez notre boutique partenaire premiumbags.com\u202f:', partnershopCta: 'Voir sur premiumbags.com', storeOnlyHeader: '« {brand} » est disponible dans notre boutique', storeOnlyHint: 'Demandez une offre personnalisée par e-mail :', storeOnlyCta: 'Envoyer une demande par e-mail', tryInstead: 'Cela pourrait vous int\u00e9resser\u202f:', popularBrands: 'Marques populaires', popularCategories: 'Cat\u00e9gories populaires' },
  it: { searchSuggestions: 'Suggerimenti di ricerca', categorySuggestions: 'Categorie', brandSuggestions: 'Marche', seriesSuggestions: 'Serie', productSuggestions: 'Prodotti suggeriti', noResults: 'Nessun risultato per', allResults: 'Mostra tutti i {count} risultati', aiRecommendation: 'Raccomandazione IA', aiLoading: 'Caricamento...', allCategories: 'Tutte le categorie', inCategory: 'in', brandNotCarried: 'Non vendiamo il marchio \u201c{brand}\u201d.', partnershopHeader: 'Trovi \u201c{brand}\u201d presso il nostro shop partner', partnershopHint: 'Disponibile presso il nostro shop partner premiumbags.com:', partnershopCta: 'Vedi su premiumbags.com', storeOnlyHeader: 'Trovi “{brand}” nel nostro negozio', storeOnlyHint: 'Richiedi un’offerta personalizzata via e-mail:', storeOnlyCta: 'Invia richiesta via e-mail', tryInstead: 'Potrebbe interessarti:', popularBrands: 'Marchi popolari', popularCategories: 'Categorie popolari' },
  es: { searchSuggestions: 'Sugerencias de b\u00fasqueda', categorySuggestions: 'Categor\u00edas', brandSuggestions: 'Marcas', seriesSuggestions: 'Series', productSuggestions: 'Productos sugeridos', noResults: 'Sin resultados para', allResults: 'Mostrar los {count} resultados', aiRecommendation: 'Recomendaci\u00f3n IA', aiLoading: 'Cargando...', allCategories: 'Todas las categor\u00edas', inCategory: 'en', brandNotCarried: 'No vendemos la marca \u201c{brand}\u201d.', partnershopHeader: 'Encuentra \u201c{brand}\u201d en nuestra tienda asociada', partnershopHint: 'Disponible en nuestra tienda asociada premiumbags.com:', partnershopCta: 'Ver en premiumbags.com', storeOnlyHeader: 'Encuentra “{brand}” en nuestra tienda', storeOnlyHint: 'Solicite una oferta personalizada por correo:', storeOnlyCta: 'Enviar consulta por correo', tryInstead: 'Quiz\u00e1s le interese:', popularBrands: 'Marcas populares', popularCategories: 'Categor\u00edas populares' },
  nl: { searchSuggestions: 'Zoeksuggesties', categorySuggestions: 'Categorie\u00ebn', brandSuggestions: 'Merken', seriesSuggestions: 'Series', productSuggestions: 'Productvoorstellen', noResults: 'Geen resultaten voor', allResults: 'Alle {count} resultaten tonen', aiRecommendation: 'AI Aanbeveling', aiLoading: 'Laden...', allCategories: 'Alle categorie\u00ebn', inCategory: 'in', brandNotCarried: 'Het merk \u201e{brand}\u201d voeren wij helaas niet.', partnershopHeader: 'U vindt \u201e{brand}\u201d bij onze partnerwinkel', partnershopHint: 'Verkrijgbaar bij onze partnerwinkel premiumbags.com:', partnershopCta: 'Bekijk op premiumbags.com', storeOnlyHeader: 'U vindt „{brand}” in onze winkel', storeOnlyHint: 'Vraag per e-mail een offerte aan:', storeOnlyCta: 'Aanvraag per e-mail', tryInstead: 'Misschien interessant voor u:', popularBrands: 'Populaire merken', popularCategories: 'Populaire categorie\u00ebn' },
};
const AC = AC_I18N[TS_AC_LANG] || AC_I18N.de;

// Zubehoer-Typen die NICHT als Kategorie-Vorschlag im Autocomplete erscheinen sollen.
// (Wird im Code nur fuer die Filterung der Kategorie-Suggestions verwendet,
// nicht fuer das Such-Ranking selbst — das laeuft ueber MAIN_PRODUCT_TYPES.)
const ACCESSORY_TYPES = [
  'Zubehör','Zubehör - Reisegepäck','Schutzhülle','Schloss','Koffergurt',
  'Kofferanhänger','Regenhülle','Kofferwaage','Wechselmotiv','Magic Mags',
  'Tragegriff','Stifteetui','Lederpflege','Adressanhänger','Packbeutel',
  'Trinkflasche','Kofferschloss','Zahlenschloss',
  'Ess-Box','Brustbeutel','Schultüte',
];

// Hauptprodukte (Taschen/Koffer/Schulranzen). _eval ist max-mode, darum EIN
// einheitlicher Boost fuer die ganze Liste — sonst gewinnt die Sub-Kategorie
// mit dem hoechsten Boost gegen alles andere (z.B. Trolley/Koffer:10 hat bei
// Reisenthel den bs=1 Kindertrolley ueber den bs=34 Shopper gezogen).
const MAIN_PRODUCT_TYPES = [
  'Trolley/Koffer','Schulranzen','Schulrucksack',
  'Reisetasche','Reisetasche mit Rollen','Reisetasche ohne Rollen','Reiserucksack',
  'Rucksack','Wanderrucksack','Tagesrucksack','Trekkingrucksack','Freizeitrucksack','Kinderrucksack','Bike-Rucksack',
  'Sporttasche','Umhängetasche','Handtasche','Shopper','Clutch',
  'Aktentasche','Laptoptasche','Gürteltasche','Kulturbeutel','Beauty Case',
  'Fahrradtasche','Einkaufstrolley','Packtasche','Geldbörse',
];
const MAIN_PRODUCT_LIST_AC = MAIN_PRODUCT_TYPES.map(t => '`' + t + '`').join(',');
const MAIN_PRODUCT_BOOST = `(product_type:[${MAIN_PRODUCT_LIST_AC}]):100`;

// Marken die NICHT geführt werden — bei Match: "Marke nicht geführt" UI statt Fake-Treffer
const NOT_CARRIED_BRANDS_AC = new Set([
  'rimowa', 'rimow', 'rimoa', 'rimova',
  'patagonia', 'patagonija',
  'bogner', 'jordan', 'yeti',
  'mountain hardwear', 'arcteryx', "arc'teryx",
  'ortovox', 'liebeskind',
  'cabaia', 'travelpro', 'diesel', 'armani', 'emporio armani', 'lowepro', 'ellesse', 'briggs', 'wandrd', 'bellroy', 'michael kors', 'beckmann',
]);
function detectNotCarriedBrandAC(query) {
  const q = (query || '').toLowerCase().trim();
  if (!q) return null;
  if (NOT_CARRIED_BRANDS_AC.has(q)) return q;
  const words = q.split(/\s+/);
  if (NOT_CARRIED_BRANDS_AC.has(words[0])) return words[0];
  if (words.length >= 2 && NOT_CARRIED_BRANDS_AC.has(words.slice(0, 2).join(' '))) return words.slice(0, 2).join(' ');
  return null;
}

// Marken/Serien die wir NICHT führen, aber im Schwester-Shop premiumbags.com.
// Bei Match: Treffer unterdrücken, Hinweis-Banner mit Link.
const PARTNERSHOP_BRANDS_AC = [
  { match: ['tumi'], displayBrand: 'Tumi', url: 'https://www.premiumbags.com/search?q=tumi' },
  { match: ['ecodiver', 'eco diver', 'samsonite ecodiver', 'samsonite eco diver'], displayBrand: 'Samsonite Ecodiver', url: 'https://www.premiumbags.com/search?q=ecodiver' },
  { match: ['upscape', 'up scape', 'samsonite upscape', 'samsonite up scape'], displayBrand: 'Samsonite Upscape', url: 'https://www.premiumbags.com/search?q=upscape' },
];
function detectPartnershopBrandAC(query) {
  const q = (query || '').toLowerCase().trim();
  if (!q) return null;
  for (const entry of PARTNERSHOP_BRANDS_AC) {
    for (const kw of entry.match) {
      if (q === kw || q.includes(kw)) {
        return { displayBrand: entry.displayBrand, url: entry.url };
      }
    }
  }
  return null;
}

// Marken die wir nur stationär im Ladengeschäft führen.
const STORE_ONLY_BRANDS_AC = [
  { match: ['longchamp'], displayBrand: 'Longchamp' },
];
const STORE_ONLY_MAIL_AC = 'service@markenkoffer.de';
function detectStoreOnlyBrandAC(query) {
  const q = (query || '').toLowerCase().trim();
  if (!q) return null;
  for (const entry of STORE_ONLY_BRANDS_AC) {
    for (const kw of entry.match) {
      if (q === kw || q.includes(kw)) {
        return { displayBrand: entry.displayBrand };
      }
    }
  }
  return null;
}

// Service-Links: Keywords die auf Hilfeseiten statt Produktsuche fuehren
const SERVICE_LINKS = [
  { keywords: ['retoure', 'retouren', 'retourenschein', 'retourenformular', 'retourenschild', 'rücksendungen', 'ruecksendungen', 'rücksendeschein', 'retourneren', 'retourneer', 'retourformulier', 'retours', 'retourner', 'retourenportal', 'retourenlabel', 'retourenlabe', 'rücksendung', 'ruecksendung', 'rücksenden', 'ruecksenden', 'rückversand', 'rueckversand', 'retour', 'zurückschicken', 'zurücksenden', 'zurueckschicken', 'umtausch', 'return', 'returns', 'rückgabe', 'rueckgabe', 'reklamation', 'paket zurück', 'paket zurueck'],
    url: '/pages/retoure_dhl',
    label: { de: 'Zum Retourenportal', en: 'Go to returns portal', fr: 'Portail de retours', it: 'Portale resi', es: 'Portal de devoluciones', nl: 'Retourportaal' } },
  { keywords: ['kontakt', 'kontaktformular', 'kontaktdaten', 'telefonnummer', 'rufnummer', 'emailadresse', 'e-mail-adresse', 'kontaktieren', 'contact', 'contacteren', 'telefoonnummer', 'telefon', 'anrufen', 'email', 'e-mail', 'hotline', 'kundenservice', 'kundendienst', 'reparatur', 'reparieren', 'reparaturservice'],
    url: '/pages/kontakt',
    label: { de: 'Zum Kundenservice', en: 'Contact us', fr: 'Nous contacter', it: 'Contattaci', es: 'Contacto', nl: 'Klantenservice' } },
  { keywords: ['versand', 'versandkostenfrei', 'lieferkosten', 'lieferungen', 'verzending', 'verzendkosten', 'lieferung', 'lieferzeit', 'shipping', 'delivery', 'versandkosten', 'dhl', 'zustellung', 'liefertermin'],
    url: '/pages/versand',
    label: { de: 'Versand & Lieferung', en: 'Shipping & Delivery', fr: 'Livraison', it: 'Spedizione', es: 'Envío', nl: 'Verzending' } },
  { keywords: ['gutschein', 'gutscheincode', 'gutscheinkarte', 'geschenkkarte', 'cadeaubon', 'gutscheine', 'voucher', 'gift card', 'geschenkgutschein'],
    url: '/pages/gutscheine',
    label: { de: 'Gutscheine kaufen', en: 'Buy gift cards', fr: 'Bons d\'achat', it: 'Buoni regalo', es: 'Tarjetas regalo', nl: 'Cadeaubonnen' } },
  { keywords: ['service', 'hilfe', 'help', 'support', 'faq', 'fragen'],
    url: '/pages/service-hilfe',
    label: { de: 'Service & Hilfe', en: 'Service & Help', fr: 'Aide', it: 'Aiuto', es: 'Ayuda', nl: 'Hulp' } },
  { keywords: ['widerruf', 'widerrufsrecht', 'widerrufsbelehrung', 'widerrufsformular'],
    url: '/policies/refund-policy',
    label: { de: 'Widerrufsrecht', en: 'Right of withdrawal', fr: 'Droit de rétractation', it: 'Diritto di recesso', es: 'Derecho de desistimiento', nl: 'Herroepingsrecht' } },
  { keywords: ['datenschutz', 'datenschutzerklärung', 'privacy', 'dsgvo', 'gdpr'],
    url: '/policies/privacy-policy',
    label: { de: 'Datenschutz', en: 'Privacy Policy', fr: 'Confidentialité', it: 'Privacy', es: 'Privacidad', nl: 'Privacy' } },
  { keywords: ['agb', 'agbs', 'geschäftsbedingungen', 'terms', 'conditions'],
    url: '/policies/terms-of-service',
    label: { de: 'AGB', en: 'Terms of Service', fr: 'CGV', it: 'Termini', es: 'Condiciones', nl: 'Voorwaarden' } },
  { keywords: ['impressum', 'imprint', 'legal'],
    url: '/policies/legal-notice',
    label: { de: 'Impressum', en: 'Legal Notice', fr: 'Mentions légales', it: 'Note legali', es: 'Aviso legal', nl: 'Colofon' } },
  { keywords: ['marken', 'brands', 'markenliste', 'all brands'],
    url: '/pages/marken',
    label: { de: 'Alle Marken', en: 'All brands', fr: 'Toutes les marques', it: 'Tutte le marche', es: 'Todas las marcas', nl: 'Alle merken' } },
  { keywords: ['inspirationen', 'inspiration', 'blog', 'magazin'],
    url: '/pages/inspirationen',
    label: { de: 'Inspirationen', en: 'Inspirations', fr: 'Inspirations', it: 'Ispirazioni', es: 'Inspiraciones', nl: 'Inspiraties' } },
  { keywords: ['jobs', 'karriere', 'career', 'stellenangebote', 'stelle'],
    url: '/pages/stellenangebote',
    label: { de: 'Karriere bei uns', en: 'Careers', fr: 'Carrières', it: 'Carriere', es: 'Empleo', nl: 'Carrière' } },
  { keywords: ['unternehmen', 'firma', 'about', 'about us', 'über uns', 'company'],
    url: '/pages/unternehmen',
    label: { de: 'Über uns', en: 'About us', fr: 'À propos', it: 'Chi siamo', es: 'Sobre nosotros', nl: 'Over ons' } },
  { keywords: ['steuerfrei', 'tax free', 'taxfree', 'tax-free', 'duty free'],
    url: '/pages/steuerfrei-einkaufen',
    label: { de: 'Steuerfrei einkaufen', en: 'Tax-free shopping', fr: 'Achats hors taxes', it: 'Tax free', es: 'Compras libres de impuestos', nl: 'Belastingvrij' } },
  { keywords: ['boutique'],
    url: '/pages/boutique',
    label: { de: 'Unsere Boutique', en: 'Our boutique', fr: 'Notre boutique', it: 'La nostra boutique', es: 'Nuestra boutique', nl: 'Onze boutique' } },
  { keywords: ['newsletter', 'newsletteranmeldung', 'newsletter-anmeldung', 'newsletter anmelden', 'newsletter abonnieren', 'newsletter abmelden', 'newslettr', 'nieuwsbrief', 'abonnieren', 'subscribe', 'subscription'],
    url: '/pages/newsletter',
    label: { de: 'Newsletter abonnieren', en: 'Subscribe to newsletter', fr: 'S\'abonner à la newsletter', it: 'Iscriviti alla newsletter', es: 'Suscribirse al boletín', nl: 'Aanmelden voor nieuwsbrief' } },
];

// Nur ganze Woerter bzw. ganze Wortfolgen (gleiche Logik wie detectServiceLinkPage in typesense-search-page.js):
// Teilstrings trafen "bestellen" (stelle), "telefontasche" (telefon), "returnable" (return).
function detectServiceLink(query) {
  const qNorm = ' ' + String(query || '').toLowerCase().replace(/[^\p{L}\p{N}\s-]/gu, ' ').split(/\s+/).filter(Boolean).join(' ') + ' ';
  for (const link of SERVICE_LINKS) {
    if (link.keywords.some(kw => qNorm.includes(' ' + kw + ' '))) {
      return { url: localePathAC(link.url), label: link.label[TS_AC_LANG] || link.label.de };
    }
  }
  return null;
}

// Beliebte Suchbegriffe (angezeigt bei leerem Suchfeld)
// Reihenfolge nach echter Suchnachfrage (Typesense popular_queries_de, Stand 09/2026):
// rucksack 2978, koffer 2681, umhängetasche 1752, handgepäck 1391, schulranzen 924,
// kulturbeutel 619, shopper 616, weekender 467. Trolley/Hartschalenkoffer/Set = gleiche
// Absicht wie "Koffer" (115-968), "Sale" wird als Suchbegriff nicht genutzt (0) und
// laeuft stattdessen als Aktions-Chip aus der Announcement-Bar.
const POPULAR_SEARCHES_I18N = {
  de: ['Rucksack', 'Koffer', 'Umhängetasche', 'Handgepäck', 'Schulranzen', 'Kulturbeutel', 'Shopper', 'Weekender'],
  en: ['Backpack', 'Suitcase', 'Crossbody bag', 'Carry-on', 'School bag', 'Toiletry bag', 'Shopper', 'Weekender'],
  fr: ['Sac à dos', 'Valise', 'Sac bandoulière', 'Bagage cabine', 'Cartable', 'Trousse de toilette', 'Shopper', 'Weekender'],
  it: ['Zaino', 'Valigia', 'Borsa a tracolla', 'Bagaglio a mano', 'Cartella', 'Beauty case', 'Shopper', 'Weekender'],
  es: ['Mochila', 'Maleta', 'Bolso bandolera', 'Equipaje de mano', 'Cartera escolar', 'Neceser', 'Shopper', 'Weekender'],
  nl: ['Rugzak', 'Koffer', 'Schoudertas', 'Handbagage', 'Schooltas', 'Toilettas', 'Shopper', 'Weekender'],
};

// "Zuletzt gesucht": letzte 3 eigene Suchbegriffe im Browser (localStorage)
const _RECENT_KEY = 'ts_recent_searches';
function _getRecentSearches() {
  try {
    const a = JSON.parse(localStorage.getItem(_RECENT_KEY) || '[]');
    return Array.isArray(a) ? a.filter(x => typeof x === 'string').slice(0, 3) : [];
  } catch (e) { return []; }
}
function _addRecentSearch(q) {
  try {
    q = (q || '').trim();
    if (q.length < 2 || q.length > 40 || q === '*') return;
    const a = _getRecentSearches().filter(x => x.toLowerCase() !== q.toLowerCase());
    a.unshift(q);
    localStorage.setItem(_RECENT_KEY, JSON.stringify(a.slice(0, 3)));
  } catch (e) { /* silent */ }
}
// Auf der Suchseite den aktuellen Begriff merken (deckt Enter, Chip-Klick und Vorschlaege ab)
if (window.location.pathname.indexOf('/search') !== -1) {
  _addRecentSearch(new URLSearchParams(window.location.search).get('q') || '');
}

// Aktions-Chip: neutrales Label (Rabatthoehe wechselt), Link aus der Announcement-Bar.
// Erscheint nur, wenn dort eine Aktion verlinkt ist; ohne Aktion kein Chip.
const PROMO_CHIP_LABEL = { de: 'Aktion & Sale', en: 'Deals & Sale', fr: 'Promos & Soldes', it: 'Offerte & Saldi', es: 'Ofertas y Rebajas', nl: 'Acties & Sale' };
function _getPromoChip() {
  try {
    const a = document.querySelector('.announcement-bar--center a[href]');
    if (!a) return null;
    const href = a.getAttribute('href');
    if (!href || href === '#') return null;
    return { text: PROMO_CHIP_LABEL[TS_AC_LANG] || PROMO_CHIP_LABEL.de, href };
  } catch (e) { return null; }
}
const POPULAR_SEARCHES = POPULAR_SEARCHES_I18N[TS_AC_LANG] || POPULAR_SEARCHES_I18N.de;

let _popularSearchesCache = null;

/**
 * Holt beliebte Suchbegriffe: statische Liste + Top-Marken aus Typesense Facetten.
 * Ergebnis wird gecacht fuer die Session.
 */
async function fetchPopularSearches() {
  if (_popularSearchesCache) return _popularSearchesCache;
  const baseUrl = `${TYPESENSE_CONFIG.protocol}://${TYPESENSE_CONFIG.host}:${TYPESENSE_CONFIG.port}`;
  try {
    const resp = await fetch(`${baseUrl}/collections/${TYPESENSE_CONFIG.collection}/documents/search?q=*&query_by=title&per_page=0&facet_by=vendor,collections&max_facet_values=200&filter_by=available:true%20%26%26%20status:active`, {
      headers: { 'X-TYPESENSE-API-KEY': TYPESENSE_CONFIG.searchKey },
    });
    if (!resp.ok) throw new Error('fetch failed');
    const data = stripInternalFacets(await resp.json());
    const vendorFacet = (data.facet_counts || []).find(f => f.field_name === 'vendor');
    // Top-Marken nach Suchnachfrage (popular_queries_de 09/2026: reisenthel 9851, samsonite 2304,
    // osprey 1524, travelite 1127, step by step 878, guess 866, eastpak 710, zwei 691)
    const priorityBrands = ['Reisenthel', 'Samsonite', 'Osprey', 'Travelite', 'Step by Step', 'Guess', 'Eastpak', 'zwei'];
    const allBrands = vendorFacet ? vendorFacet.counts.filter(v => v.value.length > 3).map(v => v.value) : [];
    const byLower = new Map(allBrands.map(b => [b.toLowerCase(), b]));
    const prio = priorityBrands.map(b => byLower.get(b.toLowerCase())).filter(Boolean);
    // Priority-Marken zuerst, dann Rest nach Produktanzahl (ohne Duplikate)
    const orderedBrands = [...prio, ...allBrands.filter(b => !prio.includes(b))];
    const topBrands = orderedBrands.slice(0, 8);
    const collFacet = (data.facet_counts || []).find(f => f.field_name === 'collections');
    const hubCats = new Set(['reisegepäck','taschen','rucksäcke','accessoires & zubehör','spezialtaschen','schule / kinder','bekleidung & schuhe','koffer & trolleys']);
    const topCats = collFacet ? collFacet.counts.filter(c => !hubCats.has(c.value.toLowerCase())).slice(0, 6) : [];
    _popularSearchesCache = { brands: topBrands, categories: topCats };
    return _popularSearchesCache;
  } catch (e) {
    _popularSearchesCache = { brands: [], categories: [] };
    return _popularSearchesCache;
  }
}

/**
 * Link auf die Suchseite, kodiert wie das Suchformular (+ statt %20).
 */
function searchUrlAC(q, extra) {
  const params = new URLSearchParams({ q });
  if (extra) for (const [key, val] of Object.entries(extra)) params.set(key, val);
  return `${localePathAC('/search')}?${params.toString()}`;
}

/**
 * Rendert den "Beliebte Suchbegriffe"-Bereich bei leerem Suchfeld.
 */
function renderPopularSearches(popular) {
  const t = {
    de: { trending: 'Beliebte Suchbegriffe', topBrands: 'Top-Marken', topCategories: 'Beliebte Kategorien', recent: 'Zuletzt gesucht' },
    en: { trending: 'Popular searches', topBrands: 'Top brands', topCategories: 'Popular categories', recent: 'Recent searches' },
    fr: { trending: 'Recherches populaires', topBrands: 'Top marques', topCategories: 'Catégories populaires', recent: 'Recherches récentes' },
    it: { trending: 'Ricerche popolari', topBrands: 'Top marchi', topCategories: 'Categorie popolari', recent: 'Ricerche recenti' },
    es: { trending: 'Búsquedas populares', topBrands: 'Marcas principales', topCategories: 'Categorías populares', recent: 'Búsquedas recientes' },
    nl: { trending: 'Populaire zoekopdrachten', topBrands: 'Topmerken', topCategories: 'Populaire categorieën', recent: 'Recent gezocht' },
  }[TS_AC_LANG] || { trending: 'Beliebte Suchbegriffe', topBrands: 'Top-Marken', topCategories: 'Beliebte Kategorien', recent: 'Zuletzt gesucht' };

  let html = `<div class="thb-predictive-search--container"><div class="ts-popular-searches">`;

  const chip = (s) => `<a href="${searchUrlAC(s)}" class="ts-suggest-item ts-popular-term" data-term="${escapeHtml(s)}">${escapeHtml(s)}</a>`;

  // Zuletzt gesucht (nur wenn vorhanden), ohne Dubletten zu den beliebten Begriffen
  const popularLower = new Set(POPULAR_SEARCHES.map(s => s.toLowerCase()));
  const recent = _getRecentSearches().filter(s => !popularLower.has(s.toLowerCase()));
  if (recent.length > 0) {
    html += `<div class="ts-suggest-section ts-suggest-section--chips ts-suggest--recent">
      <div class="ts-suggest-heading">${t.recent}</div>
      ${recent.map(chip).join('')}
    </div>`;
  }

  // Suchbegriffe als Chips + Aktions-Chip aus der Announcement-Bar
  const promo = _getPromoChip();
  html += `<div class="ts-suggest-section ts-suggest-section--chips">
    <div class="ts-suggest-heading">${t.trending}</div>
    ${POPULAR_SEARCHES.map(chip).join('')}
    ${promo ? `<a href="${escapeHtml(promo.href)}" class="ts-suggest-item ts-promo-chip">${escapeHtml(promo.text)}</a>` : ''}
  </div>`;

  // Top-Marken (mit Logo wenn verfuegbar)
  if (popular.brands.length > 0) {
    const logos = window.BRAND_LOGOS || {};
    html += `<div class="ts-suggest-section ts-suggest--brands">
      <div class="ts-suggest-heading">${t.topBrands}</div>
      <div class="ts-popular-brands">
      ${popular.brands.map(b => {
        const slug = b.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        const logoUrl = logos[b.toLowerCase()] || logos[slug];
        const logoHtml = logoUrl
          ? `<img src="${logoUrl}" alt="${escapeHtml(b)}" class="ts-brand-logo">`
          : `<span class="ts-brand-name">${escapeHtml(b)}</span>`;
        return `<a href="${escapeHtml(brandUrlAC(b))}" class="ts-popular-brand">${logoHtml}</a>`;
      }).join('')}
      </div>
    </div>`;
  }

  html += `</div></div>`;
  return html;
}

// Harte Null fuer Treffer ohne Text-Treffer (Hybridsuche liefert dann nur Vektor-Zufallstreffer). minDist = kleinste
// vector_distance. Hart nur bei Gestammel UND Mindestdistanz (Tastaturreihe/Wiederholung >= 0,66, nur Vokalanteil >= 0,70)
// oder ohne Gestammel ab Distanz >= 0,76. Gestammel gilt pro Wort, rein numerische Woerter nie:
//  - Tastaturreihe: >= 4 aufeinanderfolgende Zeichen einer Reihe (vor-/rueckwaerts), bei Woertern aus Buchstaben UND Ziffern >= 3
//  - Wiederholung: >= 4 gleiche Zeichen in Folge, oder 3 gleiche bei Woertern bis 6 Zeichen
//  - Vokalanteil unter 0,2 bei 3 bis 8 Buchstaben (lange Komposita wie Schifffahrt nie) (a e i o u ae oe ue, y zaehlt nicht)
function hardNullAC(q, minDist) {
  if (!(minDist >= 0)) return false;
  if (minDist >= 0.76) return true;
  const ROWS = ['qwertzuiop\u00fc', 'asdfghjkl\u00f6\u00e4', 'yxcvbnm', 'qwertyuiop', 'asdfghjkl', 'zxcvbnm', '1234567890', 'qaywsxedc', 'plokijuhz'];
  const words = String(q || '').toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return false;
  let vowelOnly = false;
  for (const w of words) {
    if (/^\d+$/.test(w)) return false;
    const L = (/\d/.test(w) && /[a-z\u00e4\u00f6\u00fc\u00df]/.test(w)) ? 3 : 4;
    let kb = /(.)\1{3}/.test(w) || (w.length <= 6 && /(.)\1\1/.test(w));
    for (let r = 0; !kb && r < ROWS.length; r++) {
      for (let i = 0; i + L <= ROWS[r].length; i++) {
        const s = ROWS[r].slice(i, i + L);
        if (w.includes(s) || w.includes(s.split('').reverse().join(''))) { kb = true; break; }
      }
    }
    if (kb) continue;
    const letters = w.replace(/[^a-z\u00e4\u00f6\u00fc\u00df]/g, '');
    if (letters.length >= 3 && letters.length <= 8 && (letters.match(/[aeiou\u00e4\u00f6\u00fc]/g) || []).length / letters.length < 0.2) { vowelOnly = true; continue; }
    return false;
  }
  return minDist >= (vowelOnly ? 0.70 : 0.66);
}

// Embedding nur fuer DE verfuegbar (andere Sprachen haben kein embedding-Feld)
const HAS_EMBEDDING = TS_AC_LANG === 'de';

const SEARCH_DEFAULTS = {
  query_by: HAS_EMBEDDING
    ? 'title,vendor,search_keywords,tags,sku,color,material,body_html,embedding'
    : 'title,vendor,search_keywords,tags,sku,color,material,body_html',
  query_by_weights: HAS_EMBEDDING ? '10,10,4,3,2,2,1,1,1' : '10,10,4,3,2,2,1,1',
  ...(HAS_EMBEDDING ? { vector_query: 'embedding:([], k:10, alpha:0.5)' } : {}),
  // buckets:10 = Relevanz in 10 Stufen, innerhalb einer Stufe Bestseller (boost_score) zuerst
  sort_by: `_eval([${MAIN_PRODUCT_BOOST}]):desc,_text_match(buckets:10):desc,boost_score:desc`,
  per_page: 6,
  highlight_full_fields: 'title,vendor',
  highlight_start_tag: '<mark>',
  highlight_end_tag: '</mark>',
  num_typos: 2,
  text_match_type: 'max_weight',
  drop_tokens_threshold: 3,
  typo_tokens_threshold: 2,
  prioritize_exact_match: true,
  facet_by: 'vendor,collections,product_type',
  max_facet_values: 20,
  prefix: HAS_EMBEDDING
    ? 'true,false,false,false,false,false,false,false,false'
    : 'true,false,false,false,false,false,false,false',
  filter_by: 'available:true && status:active',
};

/**
 * Erkennt ob die Query ein Status-Keyword enthaelt (Sale, Neu, Neuheiten).
 * Gibt {status, cleanQuery} zurueck oder null.
 */
function detectStatusFilter(query) {
  const q = query.toLowerCase().trim();
  // Sprach-spezifisch: "sale" ist in DE/EN/NL üblich, "reduziert/angebot/rabatt" DE.
  const salePatternsByLang = {
    de: /^(sale|reduziert|angebot|angebote|rabatt|reduzierte?|%)$/i,
    en: /^(sale|discount|discounts|offer|offers|%)$/i,
    fr: /^(solde|soldes|promo|promos|réduction|reduction|%)$/i,
    it: /^(saldo|saldi|sconto|sconti|%)$/i,
    es: /^(oferta|ofertas|descuento|descuentos|rebaja|rebajas|%)$/i,
    nl: /^(sale|aanbieding|aanbiedingen|korting|kortingen|%)$/i,
  };
  // "neu" nur DE. "new" nur EN. "Nouveautés" FR etc.
  // Im DE bewusst OHNE "new" — kollidiert mit englischen Produktnamen (BOSS New Crosstown)
  const neuPatternsByLang = {
    de: /^(neu|neuheit|neuheiten|neue|neues|neuer)$/i,
    en: /^(new|new arrivals)$/i,
    fr: /^(nouveau|nouvelle|nouveautes|nouveautés)$/i,
    it: /^(nuovo|nuova|novita|novità)$/i,
    es: /^(nuevo|nueva|novedad|novedades)$/i,
    nl: /^(nieuw|nieuwe|nieuwtjes)$/i,
  };
  const salePatterns = salePatternsByLang[TS_AC_LANG] || salePatternsByLang.de;
  const neuPatterns = neuPatternsByLang[TS_AC_LANG] || neuPatternsByLang.de;
  const words = q.split(/\s+/);
  // Nur bei kurzen Queries als Status werten (>=4 Wörter = wahrscheinlich Produktname)
  if (words.length >= 4) return null;
  for (let i = 0; i < words.length; i++) {
    if (salePatterns.test(words[i])) {
      const rest = words.filter((_, idx) => idx !== i).join(' ').trim();
      return { status: 'SALE', cleanQuery: rest || '*', label: { de:'Sale', en:'Sale', fr:'Soldes', it:'Saldi', es:'Ofertas', nl:'Sale' }[TS_AC_LANG] || 'Sale' };
    }
    if (neuPatterns.test(words[i])) {
      const rest = words.filter((_, idx) => idx !== i).join(' ').trim();
      return { status: 'Neu', cleanQuery: rest || '*', label: { de:'Neuheiten', en:'New arrivals', fr:'Nouveautés', it:'Novità', es:'Novedades', nl:'Nieuw' }[TS_AC_LANG] || 'Neuheiten' };
    }
  }
  return null;
}

/**
 * Erkennt ob eine Query natuerliche Sprache ist — aktuell deaktiviert.
 * Semantische Hybrid-Suche ueber Embeddings liefert bessere Ergebnisse.
 */
function isNaturalLanguageQuery(query) {
  return false;
}

/**
 * Multi-Search: Produkt-Ergebnisse + Serien-Zaehlung in einem Request.
 * Bei natuerlichen Queries wird Conversation Search aktiviert (KI-Antwort + Produkte).
 * Embedding-Feld sorgt fuer semantische Hybrid-Suche bei allen Queries.
 */
// Interne Steuer-Collections und -Tags (Pricing/Merchandising) duerfen nie als Vorschlag,
// Kategorie oder Filter erscheinen. Handles/Tags kleingeschrieben.
// Sale-/Aktions-Collections (kundenseitig verlinkt, aber nicht als Suchvorschlag gewuenscht, Stefan 05.09.2026)
const HIDDEN_COLLECTION_HANDLES = new Set(['vollpreisartikel', 'end-of-season-sale', 'sale-taschen', 'sale-rucksaecke', 'sale-koffer', 'lagerraeumung']);
const HIDDEN_COLLECTION_TITLES = new Set(['vollpreisartikel', 'end of season sale', 'sale taschen', 'sale rucksäcke', 'sale koffer & reisegepäck', 'lagerräumung']);
const HIDDEN_TAGS = new Set(['langsamläufer', 'langsamlaeufer', 'vollpreis', 'streichpreis', 'preissensibel', 'abverkaufen']);
function _isHiddenCollection(title, handle) {
  return HIDDEN_COLLECTION_TITLES.has((title || '').toLowerCase()) || HIDDEN_COLLECTION_HANDLES.has((handle || '').toLowerCase());
}
function _isHiddenTag(tag) {
  const t = (tag || '').toLowerCase();
  return HIDDEN_TAGS.has(t) || t.startsWith('size-group:');
}
// Entfernt interne Collections/Tags aus Facetten und Treffer-Dokumenten eines Typesense-Results
function stripInternalFacets(result) {
  if (!result) return result;
  for (const f of (result.facet_counts || [])) {
    if (f.field_name === 'collections') f.counts = (f.counts || []).filter(c => !_isHiddenCollection(c.value, ''));
    if (f.field_name === 'tags') f.counts = (f.counts || []).filter(c => !_isHiddenTag(c.value));
  }
  for (const h of (result.hits || [])) {
    const d = h.document;
    if (!d) continue;
    if (Array.isArray(d.collections)) {
      const handles = Array.isArray(d.collection_handles) ? d.collection_handles : [];
      const keep = d.collections.map((c, i) => [c, handles[i]]).filter(([c, hd]) => !_isHiddenCollection(c, hd));
      d.collections = keep.map(k => k[0]);
      if (handles.length) d.collection_handles = keep.map(k => k[1]);
    }
    if (Array.isArray(d.tags)) d.tags = d.tags.filter(t => !_isHiddenTag(t));
  }
  return result;
}

async function typesenseSearch(query, options = {}, signal) {
  const baseUrl = `${TYPESENSE_CONFIG.protocol}://${TYPESENSE_CONFIG.host}:${TYPESENSE_CONFIG.port}`;
  const useConversation = isNaturalLanguageQuery(query);

  // Status-Keyword erkennen (sale, neu, neuheiten -> custom_status Filter)
  const statusFilter = detectStatusFilter(query);
  const baseFilter = 'available:true && status:active';
  let effectiveFilter = statusFilter
    ? `${baseFilter} && custom_status:=${statusFilter.status}`
    : baseFilter;
  let effectiveQuery = statusFilter ? statusFilter.cleanQuery : query;

  // Maße-Suche "55x40x23" / "55 x 40 x 23 cm" -> Filter auf hoehe_cm/breite_cm/tiefe_cm (±2cm)
  const _dimMatch = effectiveQuery.match(/\b(\d{2,3})\s*[x*×X]\s*(\d{2,3})\s*[x*×X]\s*(\d{2,3})\s*(?:cm)?\b/);
  if (_dimMatch) {
    const h = parseInt(_dimMatch[1], 10);
    const b = parseInt(_dimMatch[2], 10);
    const t = parseInt(_dimMatch[3], 10);
    effectiveFilter += ` && hoehe_cm:[${h-2}..${h+2}] && breite_cm:[${b-2}..${b+2}] && tiefe_cm:[${t-2}..${t+2}]`;
    effectiveQuery = effectiveQuery.replace(/\b\d{2,3}\s*[x*×X]\s*\d{2,3}\s*[x*×X]\s*\d{2,3}\s*(?:cm)?\b/, '').trim();
    if (!effectiveQuery) effectiveQuery = '*';
  }

  // Gepäckart-Detection: "weichgepäck"/"hartschale" -> Filter auf gepaeckart-Facette.
  // Ohne diesen Filter fuzzy-matched "weichgepäck" auf alle Nylon-Taschen via Material-Feld.
  const _gepaeckartPatterns = {
    'Weichgepäck': /\b(weichgep(?:ä|a|ae)ck|weichschalen?(?:koffer)?|softcase|softshell|stoffkoffer)\b/i,
    'Hartgepäck': /\b(hartgep(?:ä|a|ae)ck|hartschalen?(?:koffer)?|hardshell|hardcase|aluminiumkoffer|alukoffer)\b/i,
  };
  for (const [value, pattern] of Object.entries(_gepaeckartPatterns)) {
    if (pattern.test(effectiveQuery)) {
      effectiveFilter += ` && gepaeckart:=\`${value}\``;
      effectiveQuery = effectiveQuery.replace(pattern, '').trim();
      if (!effectiveQuery) effectiveQuery = '*';
      break;
    }
  }

  // Rollensystem-Detection: "4 rollen"/"spinner"/"vier rollen" -> rollensystem-Filter
  const _rollensystemPatterns = {
    '4 Rollen': /\b(4[\s\-]?rollen|vier[\s\-]?rollen|spinner|4[\s\-]?wheel)\b/i,
    '2 Rollen': /\b(2[\s\-]?rollen|zwei[\s\-]?rollen|2[\s\-]?wheel)\b/i,
  };
  for (const [value, pattern] of Object.entries(_rollensystemPatterns)) {
    if (pattern.test(effectiveQuery)) {
      effectiveFilter += ` && rollensystem:=\`${value}\``;
      effectiveQuery = effectiveQuery.replace(pattern, '').trim();
      if (!effectiveQuery) effectiveQuery = '*';
      break;
    }
  }

  // Deutsche Stoppwörter entfernen (verbessert "schulranzen für mädchen", "koffer mit 4 rollen")
  // Wortgrenze per Leerraum statt \b: \b greift vor Umlauten ("über") nie.
  const _stopwords = /(^|\s)(für|fuer|mit|und|oder|von|aus|bei|zum|zur|ein|eine|einen|einem|einer|der|die|das|den|dem|des|ist|sind|hat|haben|wird|kann|nach|über|ueber|unter|zwischen|ohne|gegen|sehr|auch|nur|aber|noch|schon|mehr|viel|ganz)(?=\s|$)/gi;
  effectiveQuery = effectiveQuery.replace(_stopwords, ' ');

  // Typesense-Operatoren neutralisieren: führendes - (exclude) / + (must) am Wortanfang entfernen,
  // Klammern entfernen. Verhindert Bug beim Copy-Paste von Produkttiteln mit "+" / "-".
  effectiveQuery = effectiveQuery.replace(/(^|\s)[+\-]+(?=\S)/g, '$1');
  effectiveQuery = effectiveQuery.replace(/[()]/g, ' ');
  effectiveQuery = effectiveQuery.replace(/\s{2,}/g, ' ').trim();
  if (!effectiveQuery) effectiveQuery = '*';

  // Vendor-Boost: wenn Query exakt ein Markenname ist, Produkte dieser Marke nach oben
  // Vendor-Map: lowercase -> Original-Schreibweise (fuer case-sensitive _eval)
  if (!window._tsVendorMap) {
    window._tsVendorMap = {};
    // BRAND_NAMES hat lowercase -> Original-Case (z.B. "samsonite" -> "Samsonite")
    if (window.BRAND_NAMES) {
      for (const [key, val] of Object.entries(window.BRAND_NAMES)) {
        window._tsVendorMap[key.toLowerCase()] = val;
      }
    }
  }
  const qLower = effectiveQuery.toLowerCase().trim();
  let vendorBoostSort = null;
  const matchedVendorName = window._tsVendorMap[qLower];
  if (matchedVendorName) {
    // Pure Vendor-Query: Hauptprodukte der Marke > restliche Markenartikel > fremde Hauptprodukte.
    // _eval ist first-match (nicht additiv): frueher stand (vendor):20 VOR (MAIN):100, dadurch rankten
    // fremde Hauptprodukte (z.B. KLICKfix-Fahrradkoerbe bei "reisenthel") ueber der Marke selbst und die
    // boost_score-Stufen griffen nie. boost_score:desc als zweiter Schluessel sortiert die Bestseller.
    vendorBoostSort = `_eval([(vendor:\`${matchedVendorName}\` && product_type:[${MAIN_PRODUCT_LIST_AC}]):120,(vendor:\`${matchedVendorName}\`):20,(product_type:[${MAIN_PRODUCT_LIST_AC}]):5]):desc,boost_score:desc,_text_match:desc`;
  }

  // Haupt-Produktsuche (immer mit Embeddings fuer Hybrid-Suche)
  // Bei Marken-Query: body_html ausschliessen damit Facet-Counts mit der Suchseite uebereinstimmen
  // (verhindert false-positives wenn andere Marken den Markennamen im Beschreibungstext erwaehnen)
  // Pure Vendor-Query: kein Embedding (Semantik würde Bestseller-Sortierung überlagern).
  const vendorOverride = matchedVendorName ? {
    query_by: 'title,vendor,search_keywords,tags,sku,color,material',
    query_by_weights: '10,10,4,3,2,2,1',
    prefix: 'true,false,false,false,false,false,false',
  } : {};

  // Bei spezifischer Produkt-Query (Klammern, lange Query, Maße): MAIN_PRODUCT_BOOST weglassen,
  // damit das exakte Match nicht von Kategorie-Boosts überstimmt wird (z.B. Handtasche +5 > Kreditkartenetui +0)
  const _specificQuery = _isSpecificProductQuery(query);
  const _specificSort = _specificQuery ? { sort_by: '_text_match:desc,boost_score:desc' } : {};

  // SEARCH_DEFAULTS clone und bei Pure Vendor das vector_query rauswerfen
  const _searchDefaults = { ...SEARCH_DEFAULTS };
  if (matchedVendorName) delete _searchDefaults.vector_query;

  const productSearch = {
    collection: TYPESENSE_CONFIG.collection,
    q: effectiveQuery,
    ..._searchDefaults,
    ...vendorOverride,
    filter_by: effectiveFilter,
    facet_by: 'vendor,collections,product_type,tags',
    ...(vendorBoostSort ? { sort_by: vendorBoostSort } : {}),
    ..._specificSort,
    ...options,
  };

  // Serien-Suche (nur Text, kein Embedding)
  const seriesSearch = {
    collection: TYPESENSE_CONFIG.collection,
    q: effectiveQuery,
    query_by: 'title,vendor,search_keywords,tags',
    filter_by: effectiveFilter,
    per_page: 50,
    prefix: 'true',
    num_typos: 2,
  };

  // Suchvorschlaege: holt 30 Treffer fuer Titelwort-Extraktion
  const suggestionSearch = {
    collection: TYPESENSE_CONFIG.collection,
    q: effectiveQuery,
    query_by: 'title,product_type,tags,search_keywords',
    query_by_weights: '10,8,5,3',
    filter_by: effectiveFilter,
    per_page: 30,
    facet_by: 'collections,tags',
    max_facet_values: 30,
    prefix: 'true',
    num_typos: 1,
    include_fields: 'title,collections,collection_handles,tags',
    };

  const body = { searches: [productSearch, seriesSearch, suggestionSearch] };

  const response = await fetch(`${baseUrl}/multi_search`, {
    method: 'POST',
    headers: {
      'X-TYPESENSE-API-KEY': TYPESENSE_CONFIG.searchKey,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    signal,
  });

  if (!response.ok) throw new Error(`Typesense error: ${response.status}`);
  const data = await response.json();
  (data.results || []).forEach(stripInternalFacets);

  let productData = data.results[0];
  const seriesData = data.results[1];
  const suggestionData = data.results[2];

  // Hybrid-Suche (DE) liefert ohne Text-Treffer bis zu k reine Vektor-Treffer (z. B. "xyzqwk"). Harte Null nur laut
  // hardNullAC (Gestammel + Mindestdistanz oder Distanz >= 0,76) UND wenn auch eine reine Textsuche (inkl. body_html)
  // nichts findet; sonst bleiben die Produkte wie bisher. Schlaegt die Gegenpruefung fehl: nichts aendern.
  if (HAS_EMBEDDING && !matchedVendorName && productSearch.vector_query && effectiveQuery !== '*'
      && (productData.found || 0) > 0 && (productData.found || 0) <= 10
      && (productData.hits || []).length > 0
      && productData.hits.every(h => !h.text_match && typeof h.vector_distance === 'number')
      && hardNullAC(effectiveQuery, Math.min(...productData.hits.map(h => h.vector_distance)))) {
    let hasTextHitAC = true;
    try {
      const chk = { ...productSearch, sort_by: '_text_match:desc', per_page: 1 };
      delete chk.facet_by; delete chk.max_facet_values; delete chk.vector_query;
      // Embedding-Feld aus query_by/Gewichten/Prefix entfernen (letzter Eintrag), reine Textsuche
      ['query_by', 'query_by_weights', 'prefix'].forEach(k => { if (chk[k]) chk[k] = String(chk[k]).split(',').slice(0, -1).join(','); });
      const chkResp = await fetch(`${baseUrl}/multi_search`, {
        method: 'POST',
        headers: { 'X-TYPESENSE-API-KEY': TYPESENSE_CONFIG.searchKey, 'Content-Type': 'application/json' },
        body: JSON.stringify({ searches: [chk] }),
        signal,
      });
      if (chkResp.ok) {
        const chkData = await chkResp.json();
        const r0 = chkData.results?.[0];
        if (r0 && !r0.error) hasTextHitAC = (r0.hits || []).some(h => h.text_match > 0);
      }
    } catch (e) {
      if (e && e.name === 'AbortError') throw e;
    }
    if (!hasTextHitAC) {
      productData.hits = [];
      productData.found = 0;
    }
  }

  // Bei natuerlicher Sprache: Conversation Search non-blocking nachladen
  if (useConversation && productData.found > 0) {
    productData._ai_pending = true;
    productData._ai_query = query;
  }

  // Vendor-Map erweitern mit Facetten-Daten (lowercase -> Original-Case)
  if (!window._tsVendorMap) window._tsVendorMap = {};
  const vFacet = (productData.facet_counts || []).find(f => f.field_name === 'vendor');
  if (vFacet) {
    for (const c of vFacet.counts) {
      window._tsVendorMap[c.value.toLowerCase()] = c.value;
    }
  }

  // Serien aus den 50 Treffern extrahieren — sortiert nach Verkaufszahlen (boost_score)
  const seriesCount = {};
  for (const hit of (seriesData?.hits || [])) {
    const doc = hit.document;
    const series = extractSeries(doc.title, doc.vendor);
    if (series) {
      const fullName = `${doc.vendor} ${series}`;
      if (!seriesCount[fullName]) {
        seriesCount[fullName] = { vendor: doc.vendor, series, count: 0, boostSum: 0 };
      }
      seriesCount[fullName].count++;
      seriesCount[fullName].boostSum += (doc.boost_score || 0);
    }
  }

  const seriesList = Object.entries(seriesCount)
    .map(([name, info]) => ({ name, ...info }))
    .sort((a, b) => b.boostSum - a.boostSum || b.count - a.count);

  productData._series = seriesList;
  productData._statusFilter = statusFilter;
  productData._originalQuery = query;
  productData._matchedVendor = matchedVendorName || null;

  // Suchvorschlaege aus Facetten und Titeln extrahieren
  productData._searchSuggestions = buildSearchSuggestions(productData, suggestionData, statusFilter ? effectiveQuery : query);

  return productData;
}

/**
 * Rendert ein einzelnes Produkt-Ergebnis - groesseres Bild, kompakter Text.
 */
function renderProductCard(hit) {
  const doc = hit.document;
  const highlight = hit.highlight || {};
  const title = highlight.title?.snippet || doc.title;
  const mpAC = marketPriceOfAC(doc);
  const price = formatPrice(mpAC.price);
  // UVP-Streichpreis + Sale-Hervorhebung fuer bestimmte Marken ausblenden (z.B. Ortlieb - keine UVP-Anzeige erlaubt).
  // Gleiche Liste wie in snippets/product-price.liquid.
  const hideUvp = UVP_HIDDEN_VENDORS.includes((doc.vendor || '').trim().toLowerCase());
  const compareAtPrice = mpAC.compare && !hideUvp ? formatPrice(mpAC.compare) : null;

  const imageUrl = doc.image_url
    ? doc.image_url.replace(/\.([a-z]+)\?/, '_200x.$1?')
    : null;

  const productUrl = localePathAC('/products/' + encodeURIComponent(doc.handle));

  const vendor = doc.vendor || '';
  // Titel ohne Vendor-Prefix fuer kompaktere Darstellung
  let cleanTitle = doc.title || '';
  if (vendor && cleanTitle.toLowerCase().startsWith(vendor.toLowerCase())) {
    cleanTitle = cleanTitle.substring(vendor.length).replace(/^\s*[-–—]\s*/, '').trim();
  }

  return `
    <a href="${productUrl}" class="ts-product" title="${escapeHtml(doc.title)}" data-product-id="${doc.shopify_id || doc.id}">
      <div class="ts-product-img">
        ${imageUrl
          ? `<img src="${imageUrl}" alt="${escapeHtml(doc.image_alt || doc.title)}" width="120" height="120">`
          : `<div class="ts-product-placeholder"></div>`
        }
      </div>
      <div class="ts-product-info">
        <div class="ts-product-vendor">${escapeHtml(vendor)}</div>
        <div class="ts-product-title">${escapeHtml(cleanTitle)}</div>
        <div class="ts-product-price">
          ${compareAtPrice && doc.on_sale
            ? `<span class="ts-price-old">${compareAtPrice}</span> `
            : ''
          }
          <span class="ts-price-current${doc.on_sale && doc.custom_status === 'SALE' && !hideUvp ? ' ts-price-sale' : ''}">${price}</span>
        </div>
      </div>
    </a>
  `;
}

/**
 * Extrahiert den Seriennamen aus einem Produkttitel.
 */
function extractSeries(title, vendor) {
  if (!title || !vendor) return null;
  let rest = title;
  if (rest.toLowerCase().startsWith(vendor.toLowerCase())) {
    rest = rest.slice(vendor.length).trim();
  }
  const dashIdx = rest.indexOf(' - ');
  if (dashIdx > 0) {
    rest = rest.slice(0, dashIdx).trim();
  }
  rest = rest.replace(/\s+\d+[\s,]*(cm|l|liter|kg|tlg\.?|er set).*$/i, '').trim();
  if (rest.length < 2 || rest.length > 50) return null;
  return rest;
}

/**
 * Extrahiert Suchvorschlaege aus Produkttiteln, Produkttypen und Tags.
 * Findet zusammengesetzte Begriffe und Bindestrich-Woerter die zur Query passen.
 */
function buildSearchSuggestions(productData, suggestionData, query) {
  const q = query.toLowerCase().trim();
  if (q.length < 2) return [];

  const seen = new Set();
  seen.add(q); // Query selbst nicht als Vorschlag zeigen
  const suggestions = [];

  // Alle Hits zusammen: productData (6) + suggestionData (30) fuer breitere Extraktion
  const allHits = [
    ...(productData.hits || []),
    ...(suggestionData?.hits || []),
  ];

  // Collection Title -> Handle Map aus Suchergebnissen aufbauen
  for (const hit of allHits) {
    const doc = hit.document || {};
    const cols = doc.collections || [];
    const handles = doc.collection_handles || [];
    for (let i = 0; i < cols.length; i++) {
      if (cols[i] && handles[i]) {
        _collectionHandleMap[cols[i].toLowerCase()] = handles[i];
      }
    }
  }

  // Alle Facetten zusammen
  const allFacets = [
    ...(productData.facet_counts || []),
    ...(suggestionData?.facet_counts || []),
  ];

  // 1. Collections die den Suchbegriff enthalten
  for (const facet of allFacets) {
    if (facet.field_name !== 'collections') continue;
    for (const c of (facet.counts || [])) {
      if (!c.value || c.count === 0) continue;
      const val = c.value.toLowerCase();
      if (val.includes(q) && !seen.has(val)) {
        seen.add(val);
        suggestions.push({ text: c.value, count: c.count, source: 'collections' });
      }
    }
  }

  // 2. Tags die den Suchbegriff enthalten (nur relevante, keine internen)
  for (const facet of allFacets) {
    if (facet.field_name !== 'tags') continue;
    for (const c of (facet.counts || [])) {
      if (!c.value || c.count === 0) continue;
      const val = c.value.toLowerCase();
      // Interne Tags ueberspringen
      if (val.startsWith('parent:') || val.startsWith('size-group:') ||
          /^[A-Z_]+$/.test(c.value) || /^\d{4}_/.test(c.value)) continue;
      if (val.includes(q) && !seen.has(val)) {
        seen.add(val);
        suggestions.push({ text: c.value, count: c.count, source: 'tags' });
      }
    }
  }

  // 3. Zusammengesetzte Woerter und Bindestrich-Kompositionen aus Titeln
  // "rolle" -> "Rollenreisetasche", "4-Rollen-Trolley", "2-Rollen-Kabinentrolley"
  const titleTerms = {};
  for (const hit of allHits) {
    const title = hit.document?.title || '';

    // Einzelwoerter pruefen (z.B. "Rollenreisetasche")
    const singleWords = title.split(/[\s,()]+/);
    for (const word of singleWords) {
      const clean = word.replace(/^[-/]+|[-/]+$/g, '');
      if (clean.length < 4) continue;
      const wLow = clean.toLowerCase();
      if (wLow.includes(q) && !seen.has(wLow)) {
        if (!titleTerms[wLow]) titleTerms[wLow] = { text: clean, count: 0 };
        titleTerms[wLow].count++;
      }
    }

    // Bindestrich-Komposita pruefen (z.B. "4-Rollen-Trolley", "2-Rollen-Kabinentrolley")
    const compounds = title.match(/\S*\w+-\w+(?:-\w+)*/g) || [];
    for (const comp of compounds) {
      const cLow = comp.toLowerCase();
      if (cLow.includes(q) && !seen.has(cLow) && comp.length > 4) {
        if (!titleTerms[cLow]) titleTerms[cLow] = { text: comp, count: 0 };
        titleTerms[cLow].count++;
      }
    }
  }

  // Titel-Terme nach Haeufigkeit sortiert hinzufuegen
  const sortedTerms = Object.values(titleTerms).sort((a, b) => b.count - a.count);
  for (const t of sortedTerms.slice(0, 8)) {
    if (!seen.has(t.text.toLowerCase())) {
      seen.add(t.text.toLowerCase());
      suggestions.push({ text: t.text, count: t.count, source: 'title' });
    }
  }

  // Nach Relevanz sortieren: Collections > Tags > Titel, dann nach Count
  const priority = { collections: 0, tags: 1, title: 2 };
  suggestions.sort((a, b) => {
    const pa = priority[a.source] ?? 3;
    const pb = priority[b.source] ?? 3;
    if (pa !== pb) return pa - pb;
    return b.count - a.count;
  });

  return suggestions.slice(0, 8);
}

/**
 * Baut Suchvorschlaege: Kategorien, Marken, Serien.
 */
function buildSuggestions(data, query, statusFilter) {
  const queryLower = query.toLowerCase().trim();
  const facets = data.facet_counts || [];
  const result = { categories: [], vendors: [], series: [] };
  const statusLabel = statusFilter ? statusFilter.label : null;
  const originalQuery = data._originalQuery || query;

  // Kategorievorschlaege: collections Facetten, Hub-Kategorien ans Ende
  const handleMap = _collectionHandleMap || {};
  const hubCategories = new Set(['reisegepäck', 'taschen', 'rucksäcke', 'accessoires & zubehör', 'spezialtaschen', 'schule / kinder', 'bekleidung & schuhe', 'koffer & trolleys']);
  // Zubehoer-Collections ans Ende (wie Hub-Kategorien)
  const accessoryCollections = new Set([
    'trinkflaschen', 'kletties & klett-button', 'schultüten', 'schlösser',
    'koffergurte', 'regenhüllen', 'schutzhüllen', 'kofferanhänger',
    'kofferwaagen', 'adressanhänger', 'packbeutel', 'lederpflege',
    'wechselmotive', 'magic mags', 'regenschirme', 'taschenschirm',
  ]);

  // Vendor aus vorheriger Erkennung (BRAND_NAMES Map) uebernehmen
  const matchedVendor = data._matchedVendor || null;

  const collFacet = facets.find(f => f.field_name === 'collections');
  if (collFacet) {
    const specific = [];
    const hubs = [];
    const hiddenCollections = new Set(['newsletter artikel nach marge']);
    for (const t of collFacet.counts.slice(0, 15)) {
      if (!t.value || hiddenCollections.has(t.value.toLowerCase())) continue;
      const handle = handleMap[t.value.toLowerCase()];
      // Immer ueber Typesense-Suchseite mit Collection-Filter
      const url = searchUrlAC(originalQuery, { collection: t.value });
      // Bei Status-Filter: "Sale in Koffer & Trolleys (12)" statt "sale in ..."
      const displayText = statusLabel
        ? `<strong>${escapeHtml(statusLabel)}</strong> ${AC.inCategory} <span style="color:var(--color-accent,#c00)">${escapeHtml(t.value)}</span>`
        : `<strong>${escapeHtml(query)}</strong> ${AC.inCategory} <span style="color:var(--color-accent,#c00)">${escapeHtml(t.value)}</span>`;
      const entry = {
        text: displayText,
        rawText: `${originalQuery} ${t.value}`,
        url,
      };
      const valLower = t.value.toLowerCase();
      if (hubCategories.has(valLower) || accessoryCollections.has(valLower)) {
        hubs.push(entry);
      } else {
        specific.push(entry);
      }
    }
    // Spezifische zuerst, dann Hub/Zubehoer-Kategorien, max 5 gesamt
    result.categories = [...specific, ...hubs].slice(0, 5);
  }

  // Fallback: product_type Facetten als Kategorie-Vorschlaege (wenn Collections zu wenig liefern)
  const accessorySet = new Set(ACCESSORY_TYPES.map(t => t.toLowerCase()));
  accessorySet.add('nackenkissen'); accessorySet.add('kulturbeutel'); accessorySet.add('regenschirm');
  accessorySet.add('packtasche'); accessorySet.add('kreditkartenetui'); accessorySet.add('geldbörse');
  const ptFacet = facets.find(f => f.field_name === 'product_type');
  if (ptFacet && result.categories.length < 3) {
    const existingTexts = new Set(result.categories.map(c => c.rawText?.toLowerCase()));
    for (const pt of ptFacet.counts) {
      if (!pt.value || pt.count < 2) continue;
      if (accessorySet.has(pt.value.toLowerCase())) continue;
      const key = `${originalQuery} ${pt.value}`.toLowerCase();
      if (existingTexts.has(key)) continue;
      // Marke + Produkttyp als echter Filter (ts_f_), wie ein Facetten-Klick auf der Suchseite
      const url = matchedVendor
        ? searchUrlAC(originalQuery, { ts_f_product_type: pt.value })
        : searchUrlAC(originalQuery + ' ' + pt.value);
      const displayText = statusLabel
        ? `<strong>${escapeHtml(statusLabel)}</strong> ${AC.inCategory} <span style="color:var(--color-accent,#c00)">${escapeHtml(pt.value)}</span>`
        : `<strong>${escapeHtml(query)}</strong> ${AC.inCategory} <span style="color:var(--color-accent,#c00)">${escapeHtml(pt.value)}</span>`;
      result.categories.splice(result.categories.length > 0 ? result.categories.length - 1 : 0, 0, {
        text: displayText,
        rawText: `${originalQuery} ${pt.value}`,
        url,
      });
      if (result.categories.length >= 6) break;
    }
  }

  // "Alle Kategorien" -> Suche
  result.categories.push({
    text: `<strong>${escapeHtml(statusLabel || query)}</strong> ${AC.inCategory} <span style="color:var(--color-accent,#c00)">${AC.allCategories}</span>`,
    rawText: originalQuery,
    url: searchUrlAC(originalQuery),
  });

  // Markenvorschlaege: Vendor anzeigen wenn Query den Vendor-Namen enthaelt oder umgekehrt
  const vendorFacet = facets.find(f => f.field_name === 'vendor');
  if (vendorFacet) {
    const queryWords = queryLower.split(/\s+/);
    for (const v of vendorFacet.counts) {
      const vLower = v.value.toLowerCase();
      // Match wenn: Vendor startet mit Query, Query startet mit Vendor, oder ein Query-Wort ist der Vendor
      if (vLower.startsWith(queryLower) || queryLower.startsWith(vLower) || queryWords.some(w => w.length > 2 && vLower.startsWith(w))) {
        result.vendors.push({ text: v.value, count: v.count });
      }
    }
  }

  // Serienvorschlaege
  const seriesList = data._series || [];
  for (const s of seriesList.slice(0, 5)) {
    result.series.push({ text: s.name, count: s.count });
  }

  return result;
}

/**
 * Highlighted einen Suchvorschlag.
 */
function highlightSuggestion(text, query) {
  const q = String(query || '').trim();
  if (!q) return escapeHtml(text);
  const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // Auf dem Rohtext in Segmente schneiden und jedes Segment einzeln escapen: sonst markiert die Regex
  // innerhalb von Entities ("aunts &amp; uncles" -> "&<mark>a</mark>mp;").
  const parts = String(text == null ? '' : text).split(new RegExp(`(${escaped})`, 'gi'));
  return parts.map((part, i) => (i % 2 === 1 ? `<mark>${escapeHtml(part)}</mark>` : escapeHtml(part))).join('');
}

/**
 * Rendert eine hilfreiche "Keine Ergebnisse"-Seite mit Marken- und Kategorie-Alternativen.
 */
function renderNoResultsWithAlternatives(data, query, isIrrelevant) {
  const facets = data.facet_counts || [];
  const queryLower = query.toLowerCase().trim();

  // Service-Link pruefen — bei Retoure/Kontakt etc. direkt dorthin leiten
  const serviceLink = detectServiceLink(query);

  // Erkennen ob der Query wahrscheinlich ein Markenname ist (1-2 Woerter, keine typischen Produktbegriffe)
  const productWords = new Set(['koffer','trolley','rucksack','tasche','reisekoffer','handgepäck','set','gross','klein','leicht','hartschale','weichgepäck','schulranzen','umhängetasche','aktentasche','reise']);
  const qWords = queryLower.split(/\s+/);
  const looksLikeBrand = qWords.length <= 2 && !qWords.some(w => productWords.has(w));

  // Top Marken aus Vendor-Facetten (die tatsaechlich Ergebnisse haben)
  const vendorFacet = facets.find(f => f.field_name === 'vendor');
  const topVendors = vendorFacet ? vendorFacet.counts.slice(0, 8) : [];

  // Top Kategorien aus Collections-Facetten
  const collFacet = facets.find(f => f.field_name === 'collections');
  const hubCategories = new Set(['reisegepäck', 'taschen', 'rucksäcke', 'accessoires & zubehör', 'spezialtaschen', 'schule / kinder', 'bekleidung & schuhe', 'koffer & trolleys']);
  const topCategories = collFacet
    ? collFacet.counts.filter(c => !hubCategories.has(c.value.toLowerCase())).slice(0, 6)
    : [];

  // Header-Meldung: bei nicht geführter Marke klaren Text; sonst generisch
  const _notCarried = data._notCarriedBrand;
  const headerHtml = _notCarried
    ? `<div style="font-size:15px;">${AC.brandNotCarried.replace('{brand}', escapeHtml(_notCarried))}</div>
       <div style="margin-top:6px;color:rgba(0,0,0,.6);font-size:14px;">${AC.tryInstead}</div>`
    : `<div style="font-size:15px;">${AC.noResults} ${quoteAC(escapeHtml(query))}</div>
       <div style="margin-top:6px;color:rgba(0,0,0,.6);font-size:14px;">${AC.tryInstead}</div>`;

  // Marken-Links
  let brandsHtml = '';
  if (topVendors.length > 0) {
    brandsHtml = `
      <div class="ts-suggest-section">
        <div class="ts-suggest-heading">${AC.popularBrands}</div>
        ${topVendors.map(v => `<a href="${escapeHtml(brandUrlAC(v.value))}" class="ts-suggest-item">${escapeHtml(v.value)}</a>`).join('')}
      </div>`;
  }

  // Kategorie-Links
  let categoriesHtml = '';
  if (topCategories.length > 0) {
    const handleMap = _collectionHandleMap || {};
    categoriesHtml = `
      <div class="ts-suggest-section">
        <div class="ts-suggest-heading">${AC.popularCategories}</div>
        ${topCategories.map(c => {
          const handle = handleMap[c.value.toLowerCase()];
          const url = handle ? localePathAC('/collections/' + handle) : searchUrlAC(c.value);
          return `<a href="${url}" class="ts-suggest-item">${escapeHtml(c.value)}</a>`;
        }).join('')}
      </div>`;
  }

  // Service-Link (Retoure, Kontakt, Versand) — wenn erkannt, prominent anzeigen
  let serviceLinkHtml = '';
  if (serviceLink) {
    serviceLinkHtml = `
      <div style="margin:16px 20px 0;padding:12px 16px;background:var(--color-accent-light,#fff3f0);border-radius:8px;">
        <a href="${serviceLink.url}" style="display:flex;align-items:center;gap:10px;font-weight:600;font-size:15px;color:inherit;text-decoration:none;">
          <span style="font-size:20px;">&#128712;</span> ${escapeHtml(serviceLink.label)} &rarr;
        </a>
      </div>`;
  }

  return `
    <div class="thb-predictive-search--container">
      <div style="padding:24px 20px;">
        ${headerHtml}
      </div>
      ${serviceLinkHtml}
      <div class="ts-search-grid">
        <div class="ts-search-left">${brandsHtml}${categoriesHtml}</div>
        <div class="ts-search-right">
          <div style="text-align:center;padding:30px 20px;color:rgba(0,0,0,.35);font-size:14px;">
            ${AC.noResults} ${quoteAC(escapeHtml(query))}
          </div>
        </div>
      </div>
    </div>
  `;
}

/**
 * Rendert die komplette Ergebnisliste - zweispaltiges Layout.
 */
// Spezifische Produkt-Query erkennen: Kategorievorschläge machen dann keinen Sinn.
// Signale: Klammern, Dezimal-Maße ("12.5 cm"), HxBxT, lange spezifische Query (>=5 Wörter & >=30 Zeichen).
function _isSpecificProductQuery(q) {
  if (!q) return false;
  if (/[()]/.test(q)) return true;
  if (/\d+[.,]\d+\s*cm/i.test(q)) return true;
  if (/\d{2,3}\s*[x*×X]\s*\d{2,3}/.test(q)) return true;
  const words = q.trim().split(/\s+/);
  if (words.length >= 5 && q.length >= 30) return true;
  return false;
}

function renderStoreOnlyBannerAC(storeOnly, query) {
  const brand = escapeHtml(storeOnly.displayBrand);
  const header = AC.storeOnlyHeader.replace('{brand}', brand);
  const hint = AC.storeOnlyHint;
  const subject = encodeURIComponent(`Anfrage ${storeOnly.displayBrand}`);
  const mailto = `mailto:${STORE_ONLY_MAIL_AC}?subject=${subject}`;
  return `
    <div class="thb-predictive-search--container">
      <div style="padding:32px 24px;text-align:center;">
        <div style="font-size:36px;line-height:1;margin-bottom:12px;">&#127978;</div>
        <div style="font-size:16px;font-weight:600;margin-bottom:6px;">${header}</div>
        <div style="color:rgba(0,0,0,.65);font-size:14px;margin-bottom:18px;">${hint}</div>
        <a href="${mailto}"
           style="display:inline-flex;align-items:center;gap:8px;padding:12px 22px;background:#000;color:#fff;font-weight:600;font-size:14px;border-radius:999px;text-decoration:none;">
          &#9993; ${AC.storeOnlyCta}
        </a>
      </div>
    </div>`;
}

function renderPartnershopBannerAC(partnershop, query) {
  const brand = escapeHtml(partnershop.displayBrand);
  const header = AC.partnershopHeader.replace('{brand}', brand);
  const hint = AC.partnershopHint.replace('{brand}', brand);
  loadPartnerProductsAC(partnershop);
  return `
    <div class="thb-predictive-search--container">
      <div style="padding:32px 24px;text-align:center;">
        <div style="font-size:36px;line-height:1;margin-bottom:12px;">&#128717;</div>
        <div style="font-size:16px;font-weight:600;margin-bottom:6px;">${header}</div>
        <div style="color:rgba(0,0,0,.65);font-size:14px;margin-bottom:18px;">${hint}</div>
        <div id="ts-ac-partner-products" data-brand="${brand}" style="display:none;grid-template-columns:repeat(auto-fit,minmax(96px,1fr));gap:10px;max-width:420px;margin:0 auto 18px;"></div>
        <a href="${partnershop.url}" target="_blank" rel="noopener noreferrer"
           data-ts-partnershop="${escapeHtml(partnershop.displayBrand)}"
           style="display:inline-flex;align-items:center;gap:8px;padding:12px 22px;background:#000;color:#fff;font-weight:600;font-size:14px;border-radius:999px;text-decoration:none;">
          ${AC.partnershopCta} &rarr;
        </a>
      </div>
    </div>`;
}

// Live-Produktkarten vom Partnershop nachladen (Worker-Proxy, KV-gecacht).
// Fire-and-forget: der Banner wird synchron gerendert, die Karten kommen nach,
// sobald der Fetch resolved — schlaegt er fehl, bleibt der Text-Banner stehen.
// Promise-Cache pro Query: verhindert Request-Spam und Karten-Flackern beim
// Weitertippen (jeder Tastendruck rendert das Dropdown neu).
const _partnerProductsCache = new Map();
function loadPartnerProductsAC(partnershop) {
  let key = '';
  try { key = new URL(partnershop.url).searchParams.get('q') || ''; } catch (e) { /* ignore */ }
  if (!key) return;
  let promise = _partnerProductsCache.get(key);
  if (!promise) {
    promise = fetch(`https://ai-advisor.markenkoffer.de/partner-products?q=${encodeURIComponent(key)}`)
      .then(r => (r.ok ? r.json() : null))
      .catch(() => null);
    _partnerProductsCache.set(key, promise);
  }
  promise.then(data => {
    if (!data) _partnerProductsCache.delete(key); // Fehlschlag nicht cachen, spaeterer Retry moeglich
    const el = document.getElementById('ts-ac-partner-products');
    const products = (data && data.products) || [];
    if (!el || products.length === 0) return;
    // Dropdown wurde inzwischen fuer eine andere Marke neu gerendert? Dann nichts einsetzen.
    // (dataset liefert den dekodierten Attributwert, daher Rohwert-Vergleich)
    if (el.dataset.brand !== partnershop.displayBrand) return;
    el.innerHTML = products.map(p => `<a href="${escapeHtml(p.url)}" target="_blank" rel="noopener noreferrer"
        data-ts-partnershop="${escapeHtml(partnershop.displayBrand)}"
        style="display:block;background:#fff;border:1px solid #e4e8ed;border-radius:8px;padding:8px 8px 10px;text-align:center;text-decoration:none;color:#1a1a1a;">
      <img src="${escapeHtml(p.image)}" alt="${escapeHtml(p.title)}" style="width:100%;max-width:90px;aspect-ratio:1/1;object-fit:contain;margin-bottom:6px;">
      <div style="font-size:11.5px;line-height:1.3;max-height:3.9em;overflow:hidden;">${escapeHtml(p.title)}</div>
      <div style="font-weight:600;font-size:13px;margin-top:4px;">${formatPrice(p.price)}</div>
    </a>`).join('');
    el.style.display = 'grid';
    el.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        trackSearch('partnershop_product_click', _lastSearchQuery || key, { brand: partnershop.displayBrand, target: a.href });
      });
    });
  });
}

function renderSearchResults(data, query) {
  const hits = data.hits || [];
  const found = data.found || 0;
  const statusFilter = data._statusFilter;
  const displayQuery = statusFilter ? (statusFilter.cleanQuery === '*' ? statusFilter.label : `${statusFilter.label} ${statusFilter.cleanQuery}`) : query;

  // Stationäre Marke: nur im Ladengeschäft, Banner mit Mail-Anfrage.
  const _storeOnly = detectStoreOnlyBrandAC(query);
  if (_storeOnly) {
    return renderStoreOnlyBannerAC(_storeOnly, query);
  }

  // Partnershop-Match: Marken/Serien die wir nicht führen, aber premiumbags.com schon.
  // Treffer ausblenden, dediziertes Banner mit Link zum Partnershop.
  const _partnershop = detectPartnershopBrandAC(query);
  if (_partnershop) {
    return renderPartnershopBannerAC(_partnershop, query);
  }

  // Nicht geführte Marken: No-Results-UI zeigen, auch wenn Typesense Fake-Treffer via drop_tokens liefert
  const _notCarried = detectNotCarriedBrandAC(query);
  if (_notCarried || hits.length === 0) {
    data._notCarriedBrand = _notCarried;
    return renderNoResultsWithAlternatives(data, _notCarried || query, !!_notCarried);
  }

  const suggestions = buildSuggestions(data, query, statusFilter);
  // Bei spezifischen Produkt-Queries (Klammern, Maße, langer Titel) Kategorie-/Serien-/Such-Vorschläge unterdrücken
  const _isSpecific = _isSpecificProductQuery(query);

  // Service-Link erkennen (Retoure, Kontakt, Versand)
  const serviceLink = detectServiceLink(query);

  // Linke Spalte: Vorschlaege
  let leftHtml = '';

  // Service-Link prominent oben anzeigen
  if (serviceLink) {
    leftHtml += `
      <div class="ts-suggest-section">
        <a href="${serviceLink.url}" class="ts-suggest-item" style="background:var(--color-accent-light,#fff3f0);padding:10px 12px;border-radius:6px;font-weight:600;display:flex;align-items:center;gap:8px;">
          <span style="font-size:18px;">&#128712;</span> ${escapeHtml(serviceLink.label)} &rarr;
        </a>
      </div>
    `;
  }

  // Suchvorschlaege (Begriffe die vervollstaendigt werden)
  const searchSuggestions = data._searchSuggestions || [];
  if (searchSuggestions.length > 0 && !_isSpecific) {
    leftHtml += `
      <div class="ts-suggest-section ts-suggest-section--chips">
        <div class="ts-suggest-heading">${AC.searchSuggestions}</div>
        ${searchSuggestions.map(s =>
          `<a href="${searchUrlAC(s.text)}" class="ts-suggest-item typesense-suggestion" data-suggestion="${escapeHtml(s.text)}">
            <span class="ts-suggest-icon">&#128269;</span> ${highlightSuggestion(s.text, query)}
          </a>`
        ).join('')}
      </div>
    `;
  }

  // Kategorievorschlaege (bei spezifischer Produkt-Query unterdrücken)
  if (suggestions.categories.length > 0 && !_isSpecific) {
    leftHtml += `
      <div class="ts-suggest-section ts-suggest--categories">
        <div class="ts-suggest-heading">${AC.categorySuggestions}</div>
        ${suggestions.categories.map(c =>
          `<a href="${c.url}" class="ts-suggest-item${c.url.startsWith(localePathAC('/search')) && !/&(collection|ts_f_product_type)=/.test(c.url) ? ' typesense-suggestion" data-suggestion="' + escapeHtml(c.rawText) : ''}">${c.text}</a>`
        ).join('')}
      </div>
    `;
  }

  // Markenvorschlaege (mit Logo wenn vorhanden)
  if (suggestions.vendors.length > 0) {
    const logos = window.BRAND_LOGOS || {};
    leftHtml += `
      <div class="ts-suggest-section ts-suggest-section--chips ts-suggest--brands">
        <div class="ts-suggest-heading">${AC.brandSuggestions}</div>
        ${suggestions.vendors.map(v => {
          const vendorKey = v.text.toLowerCase();
          const vendorSlug = vendorKey.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          const logoUrl = logos[vendorKey] || logos[vendorSlug];
          const logoHtml = logoUrl
            ? `<img src="${logoUrl}" alt="${escapeHtml(v.text)}" style="height:28px;width:auto;max-width:100px;margin-right:10px;vertical-align:middle;object-fit:contain;">`
            : '';
          return `<a href="${escapeHtml(brandUrlAC(v.text))}" class="ts-suggest-item">${logoHtml}${highlightSuggestion(v.text, query)}</a>`;
        }).join('')}
      </div>
    `;
  }

  // Serienvorschlaege (bei spezifischer Produkt-Query unterdrücken)
  if (suggestions.series.length > 0 && !_isSpecific) {
    leftHtml += `
      <div class="ts-suggest-section ts-suggest--series">
        <div class="ts-suggest-heading">${AC.seriesSuggestions}</div>
        ${suggestions.series.map(s =>
          `<a href="${searchUrlAC(s.text)}" class="ts-suggest-item typesense-suggestion" data-suggestion="${escapeHtml(s.text)}">${highlightSuggestion(s.text, query)}</a>`
        ).join('')}
      </div>
    `;
  }

  // Rechte Spalte: Produkte
  const rightHtml = `
    <div class="ts-suggest-heading">${AC.productSuggestions}</div>
    <div class="ts-products-list">
      ${hits.map(hit => renderProductCard(hit)).join('')}
    </div>
  `;

  // KI-Antwort Platzhalter (volle Breite, wird non-blocking nachgeladen)
  const aiPlaceholder = data._ai_pending ? `
    <div class="ts-ai-answer" id="ts-ai-answer">
      <div class="ts-ai-label">\u{1F9E0} ${AC.aiRecommendation}</div>
      <div class="ts-ai-text" style="opacity:.4">${AC.aiLoading}</div>
    </div>
  ` : '';

  // Layout zusammenbauen: KI oben volle Breite, dann 2-Spalten
  let html = `
    <div class="thb-predictive-search--container">
      ${aiPlaceholder}
      <div class="ts-search-grid">
        <div class="ts-search-left">${leftHtml}</div>
        <div class="ts-search-right">${rightHtml}</div>
      </div>
    </div>
  `;

  // Footer
  html += `
    <div class="thb-predictive-search--footer">
      <button class="text-button" id="search-results-submit"><span>${AC.allResults.replace('{count}', found.toLocaleString(TS_AC_LANG))}</span></button>
    </div>
    <span class="loading-overlay">
      <svg class="thb-loading" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10.5" cy="10.5" r="9" stroke="currentColor" stroke-width="2" stroke-dasharray="56.5" stroke-dashoffset="14" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 10.5 10.5" to="360 10.5 10.5" dur="1s" repeatCount="indefinite"/></circle></svg>
    </span>
  `;

  return html;
}

/**
 * Formatiert die KI-Antwort: Markdown -> HTML, Produktnamen klickbar machen.
 */
function formatAiAnswer(answer, hits) {
  // Produkt-Handles Map bauen fuer klickbare Links
  const productMap = {};
  for (const hit of hits) {
    const doc = hit.document;
    productMap[doc.title.toLowerCase()] = localePathAC('/products/' + encodeURIComponent(doc.handle));
  }

  let html = escapeHtml(answer);

  // **bold** -> <strong>
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

  // Aufzaehlungszeichen: * am Zeilenanfang -> Bullet
  html = html.replace(/^[\*\-]\s+/gm, '\u2022 ');

  // Zeilenumbrueche
  html = html.replace(/\n/g, '<br>');

  // Produktnamen in Links verwandeln
  for (const hit of hits) {
    const doc = hit.document;
    const titleEsc = escapeHtml(doc.title);
    const shortTitle = titleEsc.length > 30 ? titleEsc.substring(0, 30) : titleEsc;
    // Suche nach dem Titel (oder Teilen davon) im Text
    if (html.includes(titleEsc) || html.includes(escapeHtml(doc.title.split(' - ')[0]))) {
      const searchStr = html.includes(titleEsc) ? titleEsc : escapeHtml(doc.title.split(' - ')[0]);
      html = html.replace(
        searchStr,
        `<a href="${localePathAC('/products/' + encodeURIComponent(doc.handle))}" class="ts-ai-link">${searchStr}</a>`
      );
    }
  }

  return html;
}

function formatPrice(price) {
  const localeMap = { de:'de-DE', en:'en-GB', fr:'fr-FR', it:'it-IT', es:'es-ES', nl:'nl-NL' };
  return new Intl.NumberFormat(localeMap[TS_AC_LANG] || 'de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(price);
}

function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML.replace(/"/g, '&quot;');
}

// CSS fuer zweispaltiges Layout injizieren
(function() {
  if (document.querySelector('#ts-search-css')) return;
  const style = document.createElement('style');
  style.id = 'ts-search-css';
  style.textContent = `
    .ts-search-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      min-height: 200px;
    }
    .ts-search-left {
      border-right: 1px solid var(--color-border, #e5e5e5);
      padding: 20px 24px;
    }
    .ts-search-right {
      padding: 20px 24px;
    }
    .ts-suggest-section { margin-bottom: 20px; }
    .ts-suggest-section:last-child { margin-bottom: 0; }
    .ts-suggest-heading {
      font-weight: 700;
      font-size: 1rem;
      margin-bottom: 10px;
      line-height: 1.3;
    }
    .ts-suggest-item {
      display: block;
      padding: 6px 0;
      font-size: 0.9rem;
      line-height: 1.4;
      color: inherit;
      text-decoration: none;
      transition: color .15s;
    }
    .ts-suggest-item:hover { color: var(--color-accent, #c00); }
    .ts-suggest-item mark { font-weight: 700; background: none; color: inherit; }
    .ts-suggest-icon { font-size: .75rem; margin-right: 2px; opacity: .4; }
    .ts-suggest-count { opacity: .5; font-size: .8rem; }
    @media (max-width: 749px) {
      .ts-search-grid { grid-template-columns: 1fr; }
      .ts-search-left { padding: 14px 16px; border-right: none; border-bottom: 1px solid var(--color-border, #e5e5e5); }
      .ts-search-right { padding: 14px 16px; }
      /* Mobile: nur Suchvorschlaege + Produkte, Rest ausblenden */
      .ts-suggest--categories, .ts-suggest--brands, .ts-suggest--series { display: none; }
      .ts-suggest-section { margin-bottom: 14px; }
      .ts-suggest-heading { font-size: 0.9rem; margin-bottom: 6px; }
      /* Chip-Style nur fuer kurze Items (Suchvorschlaege, Serien, Marken) */
      .ts-suggest-section--chips { display: flex; flex-wrap: wrap; gap: 6px; align-items: flex-start; }
      .ts-suggest-section--chips .ts-suggest-heading { width: 100%; margin-bottom: 4px; }
      /* inline-block statt inline-flex: bei Flex wurden Leerzeichen zwischen <mark>,
         Text und Zaehler verschluckt ("Koffer& Trolleys(1229)") */
      .ts-suggest-section--chips .ts-suggest-item {
        display: inline-block;
        padding: 7px 14px;
        background: #f5f5f5;
        border-radius: 20px;
        font-size: 0.82rem;
        line-height: 22px;
        min-height: 36px;
        white-space: normal;
      }
      .ts-suggest-icon { display: none; }
      /* Kategorie/Listen-Items: Block mit groesseren Touch-Targets */
      .ts-suggest-item { display: block; padding: 10px 0; font-size: 0.85rem; min-height: 40px; border-bottom: 1px solid #f0f0f0; }
      /* Produkte: 1-Spalten Liste (Bild links, Text rechts) */
      .ts-products-list { grid-template-columns: 1fr; gap: 8px; }
      .ts-product { flex-direction: row; align-items: center; text-align: left; gap: 10px; padding: 6px 0; border-bottom: 1px solid #f0f0f0; }
      .ts-product-img { width: 56px; height: 56px; }
      .ts-product-title { font-size: 0.78rem; -webkit-line-clamp: 2; }
      .ts-product-price { font-size: 0.78rem; }
    }
    .ts-products-list {
      display: grid;
      gap: 16px;
    }
    .ts-product {
      display: flex;
      gap: 14px;
      align-items: center;
      text-decoration: none;
      color: inherit;
      transition: opacity .15s;
    }
    .ts-product:hover { opacity: .75; }
    .ts-product-img {
      flex-shrink: 0;
      width: 80px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .ts-product-img img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
    .ts-product-placeholder {
      width: 80px;
      height: 80px;
      background: #f5f5f5;
      border-radius: 4px;
    }
    .ts-product-info { min-width: 0; }
    .ts-product-vendor {
      font-weight: 700;
      font-size: 0.85rem;
      line-height: 1.3;
      margin-bottom: 2px;
      text-transform: uppercase;
      letter-spacing: 0.02em;
    }
    .ts-product-title {
      font-size: 0.8rem;
      line-height: 1.3;
      margin-bottom: 4px;
      color: rgba(0,0,0,.55);
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .ts-product-title mark { font-weight: 700; background: none; }
    .ts-product-price { font-size: 0.875rem; }
    .ts-price-old {
      text-decoration: line-through;
      opacity: .5;
      margin-right: 4px;
    }
    .ts-price-sale { color: var(--color-accent, #c00); font-weight: 600; }
    /* Startansicht (leeres Suchfeld): Chips auch auf Desktop, feste Marken-Kacheln */
    .ts-popular-searches { padding: 22px 24px 24px; }
    .ts-popular-searches .ts-suggest-section { margin-bottom: 22px; }
    .ts-popular-searches .ts-suggest-section:last-child { margin-bottom: 0; }
    .ts-popular-searches .ts-suggest-section--chips { display: flex; flex-wrap: wrap; gap: 8px; align-items: flex-start; }
    .ts-popular-searches .ts-suggest-section--chips .ts-suggest-heading { width: 100%; margin-bottom: 4px; }
    .ts-popular-searches .ts-suggest-section--chips .ts-suggest-item {
      display: inline-flex; align-items: center; padding: 8px 16px; min-height: 36px;
      background: #f3f3f3; border-radius: 20px; font-size: 0.9rem; line-height: 1.3;
      border-bottom: none; transition: background .15s, color .15s;
    }
    .ts-popular-searches .ts-suggest-section--chips .ts-promo-chip { background: #1a1a1a; color: #fff; font-weight: 600; }
    /* Hover nur auf Geraeten mit echtem Hover: verhindert Sticky-Hover nach Tap auf iOS (bfcache/Back) */
    @media (hover: hover) {
      .ts-popular-searches .ts-suggest-section--chips .ts-suggest-item:hover { background: #1a1a1a; color: #fff; }
      .ts-popular-searches .ts-suggest-section--chips .ts-promo-chip:hover { background: #444; color: #fff; }
      .ts-popular-brand:hover { background: #eee; }
      .ts-popular-brand:hover .ts-brand-logo { filter: none; opacity: 1; }
    }
    /* Touch-Feedback: beim Antippen schwarz wie der Desktop-Hover. Klasse .ts-pressed wird per touchstart
       gesetzt, weil iOS :active nicht zuverlaessig zeigt und die Navigation schon bei mousedown startet. */
    .thb-predictive-search .ts-suggest-item, .thb-predictive-search .ts-product, .thb-predictive-search .ts-popular-brand { -webkit-tap-highlight-color: transparent; }
    .thb-predictive-search .ts-suggest-item.ts-pressed, .thb-predictive-search .ts-suggest-item:active { background: #1a1a1a !important; color: #fff !important; }
    .thb-predictive-search .ts-suggest-item.ts-pressed mark, .thb-predictive-search .ts-suggest-item:active mark { color: inherit; }
    .thb-predictive-search .ts-promo-chip.ts-pressed, .thb-predictive-search .ts-promo-chip:active { background: #555 !important; }
    .thb-predictive-search .ts-popular-brand.ts-pressed, .thb-predictive-search .ts-popular-brand:active { background: #ddd; }
    .thb-predictive-search .ts-product.ts-pressed, .thb-predictive-search .ts-product:active { background: #f0f0f0; }
    .ts-popular-searches .ts-suggest--brands .ts-suggest-heading { font-size: 11px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; color: #777; }
    .ts-popular-brands { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; }
    .ts-popular-brand {
      display: flex; align-items: center; justify-content: center;
      width: 128px; height: 56px; padding: 0; background: #f8f8f8; border-radius: 8px;
      text-decoration: none; color: inherit; transition: background .15s;
    }
    .ts-brand-logo { height: auto; max-height: 30px; width: auto; max-width: 96px; object-fit: contain; filter: grayscale(1); opacity: .75; transition: filter .15s, opacity .15s; }
    .ts-brand-name { font-size: 0.85rem; font-weight: 600; }
    @media (max-width: 749px) {
      .ts-popular-searches { padding: 14px 16px; }
      .ts-popular-searches .ts-suggest-section { margin-bottom: 14px; }
      .ts-popular-searches .ts-suggest-section--chips { gap: 8px; }
      .ts-popular-searches .ts-suggest-section--chips .ts-suggest-item { padding: 7px 14px; font-size: 0.82rem; }
      /* Marken als wischbare Reihe (ueberschreibt das generelle Ausblenden von .ts-suggest--brands) */
      .ts-popular-searches .ts-suggest--brands { display: block; }
      .ts-popular-brands { flex-wrap: nowrap; overflow-x: auto; gap: 8px; margin: 0 -16px; padding: 0 16px 2px; scrollbar-width: none; }
      .ts-popular-brands::-webkit-scrollbar { display: none; }
      .ts-popular-brand { flex: 0 0 96px; width: 96px; height: 40px; }
      .ts-brand-logo { max-height: 22px; max-width: 72px; }
    }
    /* Tastatur-Markierung (Pfeiltasten): gleiche Optik wie Hover, aber unabhaengig von (hover: hover) */
    .thb-predictive-search .ts-ac-active { outline: none; }
    .thb-predictive-search .ts-suggest-item.ts-ac-active { color: var(--color-accent, #c00); background: #f5f5f5; }
    .thb-predictive-search .ts-product.ts-ac-active { opacity: .75; background: #f5f5f5; }
    .thb-predictive-search .ts-popular-brand.ts-ac-active { background: #eee; }
    .thb-predictive-search .ts-popular-brand.ts-ac-active .ts-brand-logo { filter: none; opacity: 1; }
    .thb-predictive-search .ts-popular-searches .ts-suggest-section--chips .ts-suggest-item.ts-ac-active { background: #1a1a1a; color: #fff; }
    .thb-predictive-search .ts-popular-searches .ts-suggest-section--chips .ts-promo-chip.ts-ac-active { background: #444; color: #fff; }
    .thb-predictive-search #search-results-submit.ts-ac-active { text-decoration: underline; }
    .ts-ai-answer {
      background: linear-gradient(135deg, #f0f4ff 0%, #e8f0fe 100%);
      border-bottom: 1px solid #d0daf0;
      padding: 16px 24px;
      font-size: 0.85rem;
      line-height: 1.6;
    }
    .ts-ai-label {
      font-weight: 700;
      font-size: 0.85rem;
      margin-bottom: 8px;
      color: #4a6fa5;
    }
    .ts-ai-text { color: #333; }
    .ts-ai-text strong { color: #111; }
    .ts-ai-link {
      color: var(--color-accent, #c00);
      text-decoration: underline;
      font-weight: 600;
    }
    .ts-ai-link:hover { opacity: .7; }
    @media (max-width: 749px) {
      .ts-search-grid {
        grid-template-columns: 1fr;
      }
      .ts-search-left {
        border-right: none;
        border-bottom: 1px solid var(--color-border, #e5e5e5);
        padding: 16px;
      }
      .ts-search-right { padding: 16px; }
    }
  `;
  document.head.appendChild(style);
})();

if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this._abortController = null;
      this._currentSearchTerm = '';
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('.thb-predictive-search');
      this.cc = this.querySelector('.searchform--click-capture');

      this.setupAriaAC();
      this.setupEventListeners();
    }

    // --- Tastatur-Bedienung + ARIA (Combobox/Listbox), Fokus bleibt im Feld (aria-activedescendant) ---
    setupAriaAC() {
      if (!this.input || !this.predictiveSearchResults) return;
      this._acUid = 'ts-ac' + (window.__tsAcCount = (window.__tsAcCount || 0) + 1);
      this._activeIdxAC = -1;
      if (!this.predictiveSearchResults.id) this.predictiveSearchResults.id = this._acUid + '-listbox';
      this.predictiveSearchResults.setAttribute('role', 'listbox');
      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.input.setAttribute('aria-haspopup', 'listbox');
      this.input.setAttribute('aria-controls', this.predictiveSearchResults.id);
      this.input.setAttribute('aria-expanded', 'false');
      const sync = () => {
        const open = document.body.classList.contains('open-search');
        this.input.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) this.clearActiveAC();
      };
      new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      // Neu gerenderte Inhalte: Markierung zuruecksetzen, Optionen mit stabilen IDs versehen
      new MutationObserver(() => { this.clearActiveAC(); this.getOptionsAC(); })
        .observe(this.predictiveSearchResults, { childList: true });
    }

    // Sichtbare Eintraege in Lese-Reihenfolge (DOM-Reihenfolge: Vorschlaege, Kategorien, Marken, Serien, Produkte, Footer)
    getOptionsAC() {
      const root = this.predictiveSearchResults;
      if (!root) return [];
      const all = [...root.querySelectorAll('a.ts-suggest-item, a.ts-product, a.ts-popular-brand, #search-results-submit')]
        .filter(el => !el.closest('.ts-ai-answer'));
      // Alte eigene IDs ausgeblendeter Eintraege entfernen (sonst Duplikate nach Groessenaenderung)
      all.forEach(el => { if (el.id && el.id.indexOf(this._acUid + '-opt-') === 0) el.removeAttribute('id'); });
      const list = all.filter(el => el.getClientRects().length > 0);
      list.forEach((el, i) => {
        // Vorhandene Fremd-IDs (z. B. #search-results-submit) bleiben, eigene Index-IDs werden bei jedem Aufbau neu vergeben
        if (!el.id || el.id.indexOf(this._acUid + '-opt-') === 0) el.id = this._acUid + '-opt-' + i;
        el.setAttribute('role', 'option');
        if (!el.hasAttribute('aria-selected')) el.setAttribute('aria-selected', 'false');
      });
      return list;
    }

    clearActiveAC() {
      this._activeIdxAC = -1;
      if (!this.predictiveSearchResults) return;
      this.predictiveSearchResults.querySelectorAll('.ts-ac-active').forEach(el => {
        el.classList.remove('ts-ac-active');
        el.setAttribute('aria-selected', 'false');
      });
      if (this.input) this.input.removeAttribute('aria-activedescendant');
    }

    setActiveAC(idx, list) {
      this.clearActiveAC();
      if (idx < 0 || idx >= list.length) return;
      const el = list[idx];
      this._activeIdxAC = idx;
      el.classList.add('ts-ac-active');
      el.setAttribute('aria-selected', 'true');
      this.input.setAttribute('aria-activedescendant', el.id);
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    // Enter auf aktivem Eintrag = Linksklick: erst mousedown (Chips/Kategorien navigieren dort), sonst Klick
    activateAC(el) {
      const md = new MouseEvent('mousedown', { bubbles: true, cancelable: true, button: 0 });
      el.dispatchEvent(md);
      if (md.defaultPrevented) return;
      el.click();
    }

    async onArrowKeyAC(e) {
      const down = e.key === 'ArrowDown';
      if (!document.body.classList.contains('open-search')) {
        if (!down) return;
        e.preventDefault();
        await this.onFocus();
        if (!document.body.classList.contains('open-search')) return;
      } else {
        e.preventDefault();
      }
      const list = this.getOptionsAC();
      if (!list.length) return;
      const cur = this._activeIdxAC;
      if (down) {
        this.setActiveAC(cur < 0 ? 0 : Math.min(cur + 1, list.length - 1), list);
      } else if (cur <= 0) {
        this.clearActiveAC(); // vom ersten Eintrag zurueck ins Feld
      } else {
        this.setActiveAC(cur - 1, list);
      }
    }

    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));

      // Touch-Feedback (siehe CSS .ts-pressed): touchstart markiert das Element, Scrollen/Abbruch loest es.
      // Kein Reset bei touchend: die Navigation startet bei mousedown, der Chip bleibt bis zum Seitenwechsel schwarz.
      const results = this.predictiveSearchResults;
      const clearPressed = () => results.querySelectorAll('.ts-pressed').forEach(el => el.classList.remove('ts-pressed'));
      results.addEventListener('touchstart', (e) => {
        clearPressed();
        const item = e.target && e.target.closest ? e.target.closest('.ts-suggest-item, .ts-popular-brand, .ts-product') : null;
        if (item) item.classList.add('ts-pressed');
      }, { passive: true });
      results.addEventListener('touchmove', clearPressed, { passive: true });
      results.addEventListener('touchcancel', clearPressed, { passive: true });
      window.addEventListener('pageshow', clearPressed);

      // focusout: nur schliessen wenn Focus wirklich ausserhalb search-form geht
      this.predictiveSearchResults.addEventListener('focusout', (e) => {
        // Wenn Focus zu einem anderen Element INNERHALB search-form wechselt, nicht schliessen
        if (e.relatedTarget && this.contains(e.relatedTarget)) return;
        this.close();
      });

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 200).bind(this));

      this.cc.addEventListener('click', this.close.bind(this));

      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
          this.onArrowKeyAC(e);
        } else if (e.key === 'Enter' && this._activeIdxAC >= 0 && document.body.classList.contains('open-search')) {
          const el = this.getOptionsAC()[this._activeIdxAC];
          if (el) {
            e.preventDefault();
            this.activateAC(el);
          }
        }
      });
      // Eintippen/Loeschen: Markierung zuruecksetzen (Liste wird neu gerendert)
      this.input.addEventListener('input', () => this.clearActiveAC());

      // Escape: Chrome leert bei type=search nativ das Feld (input-Event -> onChange -> "Beliebte Suchen" oeffnen das
      // Dropdown nach 200 ms wieder). Zeitpunkt merken, damit onChange in diesem Fenster nicht wieder oeffnet.
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' || (e.code && e.code.toUpperCase() === 'ESCAPE')) {
          this._escapeAtAC = Date.now();
          const wasOpenAC = document.body.classList.contains('open-search');
          this.close();
          this.clearActiveAC();
          // Fokus zurueck ins Feld (nur wenn das Dropdown offen war oder der Fokus darin lag)
          if (this.input && (wasOpenAC || this.contains(document.activeElement)) && document.activeElement !== this.input) {
            this.input.focus();
          }
        }
      });

      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          this.close();
        }
      });

      this.input.addEventListener('focus', this.onFocus.bind(this));
    }

    getQuery() {
      const v = this.input.value.trim();
      // Nur Sonderzeichen (& < " ' * ...) wie ein leeres Feld behandeln, sonst liefert die Suche den ganzen Katalog
      return hasSearchableTextAC(v) ? v : '';
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this._currentSearchTerm = '';
        // Laufende Suche abbrechen: sonst ueberschreibt eine spaete Antwort die "Beliebten Suchen" (und "Alle N Ergebnisse" stuende bei leerem Feld)
        this.abortSearchAC();
        // Escape hat das Feld geleert: Dropdown geschlossen lassen
        if (Date.now() - (this._escapeAtAC || 0) < 1000) {
          this.close();
          return;
        }
        // Beliebte Suchbegriffe anzeigen statt zu schliessen
        this.onFocus();
        return;
      }

      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
      this.getSearchResults(searchTerm);
    }

    abortSearchAC() {
      if (this._abortController) {
        this._abortController.abort();
        this._abortController = null;
      }
      this.predictiveSearchResults.classList.remove('loading');
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    async onFocus() {
      // Fokus kommt von Escape (Fokus zurueck ins Feld): Dropdown geschlossen lassen
      if (Date.now() - (this._escapeAtAC || 0) < 300) return;
      const searchTerm = this.getQuery();

      // Leeres Suchfeld: beliebte Suchbegriffe anzeigen
      if (!searchTerm.length) {
        this.abortSearchAC();
        // Nur laden wenn noch nicht angezeigt
        if (this.predictiveSearchResults.querySelector('.ts-popular-searches')) {
          document.body.classList.add('open-search');
          this.predictiveSearchResults.removeAttribute('inert');
          return;
        }
        try {
          const popular = await fetchPopularSearches();
          // Nochmal pruefen ob User inzwischen getippt hat
          if (this.getQuery().length) return;
          this.predictiveSearchResults.innerHTML = renderPopularSearches(popular);
          document.body.classList.add('open-search');
          this.predictiveSearchResults.removeAttribute('inert');
          // Klick auf populaere Suchbegriffe: direkt zur Suchseite navigieren
          const self = this;
          this.predictiveSearchResults.querySelectorAll('.ts-popular-term').forEach(el => {
            el.addEventListener('mousedown', (e) => {
              // Rechts-/Mittelklick und Strg/Cmd/Shift-Klick dem Browser ueberlassen (Kontextmenue, neuer Tab)
              if (!isPlainLeftClickAC(e)) return;
              e.preventDefault();
              e.stopPropagation();
              const term = el.dataset.term;
              self.input.value = term;
              self.form.submit();
            });
          });
          // Aktions-Chip: direkt zur Aktions-Collection
          this.predictiveSearchResults.querySelectorAll('.ts-promo-chip').forEach(el => {
            el.addEventListener('mousedown', (e) => {
              if (!isPlainLeftClickAC(e)) return;
              e.preventDefault();
              e.stopPropagation();
              window.location.href = el.getAttribute('href');
            });
          });
        } catch (e) { /* silent */ }
        return;
      }

      // Nur cached Ergebnisse zeigen wenn sie zum aktuellen Suchbegriff passen
      if (this._currentSearchTerm === searchTerm &&
          this.predictiveSearchResults.querySelector('.thb-predictive-search--container')) {
        document.body.classList.add('open-search');
        this.predictiveSearchResults.removeAttribute('inert');
        return;
      }

      this.getSearchResults(searchTerm);
    }

    async getSearchResults(searchTerm) {
      if (this._abortController) {
        this._abortController.abort();
      }
      this._abortController = new AbortController();
      const myController = this._abortController;

      this.predictiveSearchResults.classList.add('loading');

      try {
        const data = await typesenseSearch(searchTerm, {}, myController.signal);

        // Stale-Check: wenn inzwischen eine neuere Suche gestartet wurde, ignorieren
        if (myController !== this._abortController) return;

        const found = data.found || 0;

        // Analytics: Autocomplete-Tastenschlaege NICHT tracken (verschmutzt Daten).
        // Nur Klicks + Fallbacks werden getrackt. Echte Suchen kommen von der Search Page.
        _lastSearchQuery = searchTerm;

        this.predictiveSearchResults.classList.remove('loading');
        this._currentSearchTerm = searchTerm;
        const resultsMarkup = renderSearchResults(data, searchTerm);
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        // Dropdown offen halten (falls onChange den State gesetzt hat)
        document.body.classList.add('open-search');
        this.predictiveSearchResults.removeAttribute('inert');

        // "Alle Ergebnisse" Button
        const submitButton = this.querySelector('#search-results-submit');
        if (submitButton) {
          submitButton.addEventListener('click', () => {
            this.form.submit();
          });
        }

        // Suchvorschlaege: Klick navigiert direkt zur Suchseite
        this.querySelectorAll('.typesense-suggestion').forEach(el => {
          el.addEventListener('click', (e) => {
            // Strg/Cmd/Shift-Klick: Browser oeffnet den href (sprachrichtige Suchseite) im neuen Tab/Fenster
            if (!isPlainLeftClickAC(e)) return;
            e.preventDefault();
            const suggestion = el.dataset.suggestion;
            this.input.value = suggestion;
            this.form.action = `${theme.routes.search_url}`;
            this.form.submit();
          });
        });

        // Kategorie-Links (mit &collection= oder &ts_f_product_type=): mousedown fuer zuverlaessige Navigation
        // (verhindert dass focusout das Dropdown schliesst bevor click registriert)
        this.querySelectorAll('.ts-suggest-item[href*="&collection="], .ts-suggest-item[href*="&ts_f_product_type="]').forEach(el => {
          el.addEventListener('mousedown', (e) => {
            if (!isPlainLeftClickAC(e)) return;
            e.preventDefault();
            window.location.href = el.href;
          });
        });

        // Analytics: Produkt-Klick tracken
        const lang = (window.ISO_CODE || 'DE').toLowerCase();
        this.querySelectorAll('.ts-product[data-product-id]').forEach((el) => {
          el.addEventListener('click', () => {
            trackSearch('click', searchTerm, { product_id: el.dataset.productId, lang: lang });
          });
        });

        // KI-Antwort non-blocking nachladen
        if (data._ai_pending) {
          this.loadAiAnswer(data._ai_query);
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        // Stale-Check
        if (myController !== this._abortController) return;
        console.error('Typesense search error:', error);
        this.predictiveSearchResults.classList.remove('loading');

        // Fallback auf Shopify Predictive Search
        trackSearch('fallback', searchTerm, { reason: error.message || 'unknown' });
        this.fallbackToShopify(searchTerm);
      }
    }

    fallbackToShopify(searchTerm) {
      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query,collection&${encodeURIComponent('resources[limit]')}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`)
        .then((response) => response.text())
        .then((text) => {
          const el = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search');
          if (el) {
            this.predictiveSearchResults.innerHTML = el.innerHTML;
          }
        })
        .catch(console.error);
    }

    async loadAiAnswer(query) {
      try {
        const baseUrl = `${TYPESENSE_CONFIG.protocol}://${TYPESENSE_CONFIG.host}:${TYPESENSE_CONFIG.port}`;
        const resp = await fetch(
          `${baseUrl}/multi_search?conversation=true&conversation_model_id=gemini-conv&q=${encodeURIComponent(query)}`,
          {
            method: 'POST',
            headers: {
              'X-TYPESENSE-API-KEY': TYPESENSE_CONFIG.searchKey,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ searches: [{
              collection: TYPESENSE_CONFIG.collection,
              query_by: 'title,vendor,product_type,search_keywords',
              prefix: 'true,true,true,true',
              filter_by: 'available:true && status:active',
              per_page: 10,
              include_fields: `title,vendor,handle,${PRICE_FIELD_AC},${COMPARE_FIELD_AC},groesse,volumen_liter,product_type,image_url,body_html,material,gewicht_kg`,
              nl_query: true,
              nl_model_id: 'gemini-flash',
            }] }),
          }
        );
        if (!resp.ok) return;
        const convData = await resp.json();
        const answer = convData.conversation?.answer;
        const hits = convData.results?.[0]?.hits || [];
        const el = this.querySelector('#ts-ai-answer');
        if (el && answer && this.getQuery() === query) {
          el.querySelector('.ts-ai-text').innerHTML = formatAiAnswer(answer, hits);
          el.querySelector('.ts-ai-text').style.opacity = '1';
        } else if (el && !answer) {
          el.remove();
        }
      } catch (e) {
        const el = this.querySelector('#ts-ai-answer');
        if (el) el.remove();
      }
    }

    close() {
      this.predictiveSearchResults.setAttribute('inert', '');
      document.body.classList.remove('open-search');
    }

    open() {
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
    }
  }

  customElements.define('search-form', SearchForm);
}
